/***
 * a11y.js - Shopify Accessibility Remediation Layer
 * 
 * Purpose: Post-audit fixes for WCAG 2.2 AA compliance on Shopify theme.
 * Scope: Targeted, least-destructive enhancements for carousels, modals, 
 *        mobile navigation, King swatches, Shogun components, product blocks, etc.
 * 
 *
 * Important Notes for Future Maintenance:
 * - This file contains many interdependent fixes developed over extensive testing.
 * - Refactoring should be done carefully (ideally on a staging theme).
 * - Heavy use of MutationObservers and setTimeouts exists due to Shopify theme 
 *   + third-party app timing (King, Shogun, Nosto, etc.).
 * - Do not remove installation guards (window.__a11y*Installed).
 * 
 ***/

/*** 

* PRODUCT SWATCH CONTROLS  

* SIZE CHART IMAGE ALT TEXT FALLBACK (global)

* ABRA UI VISIBILITY MANAGEMENT

* CART DRAWER MODAL FOCUS MANAGEMENT
* CART QUANTITY CONTROLS

* SIZE GUIDE MODAL FOCUS MANAGEMENT
* COOKIE BANNER: POST RENDER ADJUSTMENT
* WISHLIST CART
* AFTERPAY LOGO ACCESSIBILITY
* FOOTER

* make ACCORDIONS keyboard focusable
* TEMP: REMOVE NOSTO MOBILE MENU CAROUSEL
* NOSTO INJECTION HEADING FIX

* EASYSLIDER ACCORDION H2 WRAPPER (PRODUCT ONLY)

* PRODUCT DETAIL CAROUSEL TABINDEX CONTROL (PDP and Quick Buy drawer) 
* PRODUCT DETAIL CAROUSEL ARIA-HIDDEN SYNC (PDP and Quick Buy drawer) 

* POLICIES MODAL (in lieu of markup control)

* PRODUCT BLOCK HOVER IMAGE BUTTONS
* PRODUCT BLOCK IMAGE NAVIGATION (PREV/NEXT ARROWS) 
* PRODUCT BLOCK IMAGE STATUS ANNOUNCEMENTS

* CUSTOM SLICK SLIDER: slide group labels (ABOUT page)

* CAROUSELS / COLLECTION PAGES
 ** KING LINKED OPTIONS SWATCHES 
 ** THEME SWATCHES - Keyboard activation (Enter / Space)
 ** CAROUSEL FOCUS ESCAPE FIX
 ** FEATURED COLLECTION CAROUSEL - HIDE NON-VISIBLE SLIDES
 ** FEATURED COLLECTION CAROUSEL - NEXT BUTTON TAB ORDER FIX

* SHOGUN TABS/ACCORDIONS
* SHOGUN SIZE GUIDE PA
* SHOGUN ACCORDION HEADING FIX (H4 → H2) 
* SHOGUN TABLE HEADER FIX

* PROMOTIONAL ANNOUNCEMENT REGION (top of site)

* REGISTER FORM ERROR FOCUS

* MATTERPORT IFRAME TITLE FOR SHOWROOM PAGE (ACCESSIBLE NAME)

* PRODUCT PAGE THUMBNAIL LINKS 

* PDP KING LINKED OPTIONS COLOR SWATCH SELECTED STATE

* PDP CAROUSEL NEXT BUTTON DOM ORDER BRIDGE 

* FIT SLIDER CARD VISIBILITY AND KEYBOARD FOCUS

* NAVIGATION 
* NAVIGATION PROMO IMAGE ALT CLEANUP 
* MOBILE MENU NAVIGATION
  ** #1 - MOBILE DRAWER BUTTON KEYBOARD ACTIVATION
  ** #2 - HIDE INACTIVE TIER 1 ITEMS WHEN TIER 2 OPENS
  ** #3 - MOBILE DRAWER OPEN/CLOSE FOCUS RETURN 
  ** #7 - PREVENT FOCUS ON MENU SHADE
  ** #8 - MOBILE TIER 2 FOCUS ORDER + TIER 1 CONTENT HIDING
  ** #9 - MOBILE DRAWER FOCUS TRAP
  ** #10 - HIDE PAGE CONTENT FROM SCREEN READERS WHEN MOBILE DRAWER IS OPEN

***/

/*  find elem in focus --DEBUGGER 
(function () {
  document.addEventListener('focusin', function (e) {
    var el = e.target;
    try {
      console.log('[a11y tab]', el, {
        tag: el && el.tagName ? el.tagName.toLowerCase() : null,
        id: el && el.id ? el.id : null,
        class: el && typeof el.className === 'string' ? el.className : null,
        name: el && el.getAttribute ? (el.getAttribute('name') || null) : null,
        role: el && el.getAttribute ? (el.getAttribute('role') || null) : null,
        ariaLabel: el && el.getAttribute ? (el.getAttribute('aria-label') || null) : null,
        tabindex: el && el.getAttribute ? (el.getAttribute('tabindex') || null) : null
      });
    } catch (err) {
      console.log('[a11y tab] focusin, but logging failed', err);
    }
  }, true);

  console.log('[a11y tab] focus logger installed. Press Tab now.');
})();
*/

(function () {
  if (window.__a11yShopPayFocusInstalled) return;
  window.__a11yShopPayFocusInstalled = true;

  function getHost(el) {
    if (!el) return null;
    if (el.tagName && el.tagName.toLowerCase() === 'shop-pay-wallet-button') return el;
    return el.closest ? el.closest('shop-pay-wallet-button') : null;
  }

  document.addEventListener('focusin', function (e) {
    var host = getHost(e.target);
    if (!host) return;
    host.classList.add('a11y-focus-visible');
  }, true);

  document.addEventListener('focusout', function (e) {
    var host = getHost(e.target);
    if (!host) return;
    setTimeout(function () {
      if (!host.contains(document.activeElement)) {
        host.classList.remove('a11y-focus-visible');
      }
    }, 0);
  }, true);
})();

//*** SIZE CHART IMAGE ALT TEXT FALLBACK (global) ***//
/* TARGET BY TAG */
(function () {
  var sizeChartAltText = 'Product size chart. Full size chart information is available in the Size Guide on the product page.';

  var tagsToSkip =
    theme.settings.a11ySizeChartTagsToSkip || '';

  function productTagShouldBeSkipped() {
    var productTags = theme.productTags || [];
    var shouldSkipTag = false;

    tagsToSkip
      .split('\n')
      .forEach(function (tagToSkip) {
        if (productTags.indexOf(tagToSkip.trim()) !== -1) {
          shouldSkipTag = true;
        }
      });

    return shouldSkipTag;
  }

  function applySizeChartAltText(image) {
    if (!image) return;
    if (productTagShouldBeSkipped()) return;

    image.classList.add('a11y-size-chart-img');
    image.setAttribute('alt', sizeChartAltText);
  }

  function updateGallerySizeChartImageAltText() {
    var galleryImages = document.querySelectorAll(
      '.product-media img.theme-img'
    );

    if (galleryImages.length >= 2) {
      var lastGalleryImage = galleryImages[galleryImages.length - 1];

      applySizeChartAltText(lastGalleryImage);
    }

    var galleryThumbs = document.querySelectorAll(
      '.gallery-viewer__thumb-img'
    );

    if (galleryThumbs.length >= 2) {
      var lastGalleryThumb = galleryThumbs[galleryThumbs.length - 1];

      applySizeChartAltText(lastGalleryThumb);
    }

    var activeThumb = document.querySelector(
      '.gallery-viewer__thumb.is-active .gallery-viewer__thumb-img, .gallery-viewer__thumb-img.is-active'
    );

    var zoomImage = document.querySelector(
      '.gallery-viewer__zoom-image'
    );

    if (
      galleryThumbs.length >= 2 &&
      activeThumb === galleryThumbs[galleryThumbs.length - 1] &&
      zoomImage
    ) {
      applySizeChartAltText(zoomImage);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateGallerySizeChartImageAltText);
  } else {
    updateGallerySizeChartImageAltText();
  }

  window.addEventListener('load', updateGallerySizeChartImageAltText);

  document.addEventListener('click', function () {
    setTimeout(updateGallerySizeChartImageAltText, 100);
  });
})();
 
//*** ABRA UI VISIBILITY MANAGEMENT **//
// Prevents focus and AT exposure for offscreen ABRA notification controls.
// (function () {
//   if (!document || !document.querySelector) return;

//   function ensureStyleRule() {
//     if (document.getElementById('a11y-abra-hide')) return;
//     const s = document.createElement('style');
//     s.id = 'a11y-abra-hide';
//     s.textContent = `
//       [data-a11y-abra-hidden="true"] { display: none !important; }
//     `;
//     document.head.appendChild(s);
//   }

//   function isOffscreen(el) {
//     const r = el.getBoundingClientRect();
//     if (r.width === 0 || r.height === 0) return true;
//     if (r.bottom <= 0) return true;
//     if (r.right <= 0) return true;
//     if (r.top >= window.innerHeight) return true;
//     if (r.left >= window.innerWidth) return true;
//     return false;
//   }

//   function hideNode(node) {
//     if (!node) return;
//     ensureStyleRule();
//     node.setAttribute('data-a11y-abra-hidden', 'true');
//     node.setAttribute('aria-hidden', 'true');
//   }

//   function showNode(node) {
//     if (!node) return;
//     node.removeAttribute('data-a11y-abra-hidden');
//     node.removeAttribute('aria-hidden');
//   }

//   function disableTab(el) {
//     if (!el) return;
//     if (!el.hasAttribute('data-a11y-prev-tabindex')) {
//       const prev = el.getAttribute('tabindex');
//       el.setAttribute('data-a11y-prev-tabindex', prev === null ? '' : prev);
//     }
//     el.setAttribute('tabindex', '-1');
//   }

//   function restoreTab(el) {
//     if (!el) return;
//     if (!el.hasAttribute('data-a11y-prev-tabindex')) return;
//     const prev = el.getAttribute('data-a11y-prev-tabindex');
//     el.removeAttribute('data-a11y-prev-tabindex');
//     if (prev === '') el.removeAttribute('tabindex');
//     else el.setAttribute('tabindex', prev);
//   }

//   function updateAbraNotificationClose() {
//     const btn = document.querySelector('button.abra-notification__close');
//     if (!btn) return;

//     const offscreen = isOffscreen(btn);

//     const liveRegion = btn.closest('[role="alert"],[aria-live],[role="status"]');
//     const host = btn.closest('abra-notification');

//     if (offscreen) {
//       disableTab(btn);
//       hideNode(host);
//       hideNode(liveRegion);
//     } else {
//       restoreTab(btn);
//       showNode(host);
//       showNode(liveRegion);
//     }
//   }

//   updateAbraNotificationClose();

//   const obs = new MutationObserver(() => requestAnimationFrame(updateAbraNotificationClose));
//   obs.observe(document.documentElement, {
//     subtree: true,
//     childList: true,
//     attributes: true,
//     attributeFilter: ['class', 'style', 'role', 'aria-live', 'aria-hidden', 'tabindex']
//   });

//   document.addEventListener('focusin', (e) => {
//     if (e.target && e.target.matches && e.target.matches('button.abra-notification__close[tabindex="-1"]')) {
//       e.target.blur();
//     }
//   }, true);
// })();

//*** CART DRAWER MODAL FOCUS MANAGEMENT **//
// Ensures proper focus placement, focus containment, and focus restoration.
(function () {
  var isRedirectingFocus = false;

  var lastCartOpener = null;

  function isUsableFocusTarget(el) {
    if (!el || typeof el.focus !== 'function') return false;
    if (!document.contains(el)) return false;
    if (el.closest('[aria-hidden="true"]')) return false;
    if (el.hasAttribute('disabled')) return false;
    return true;
  }

  function getCartIcon() {
    return document.querySelector('a[href="/cart"], a[href^="/cart?"], button[aria-label*="Cart"], button[aria-controls*="cart"], [data-cart-toggle], .js-cart-toggle');
  }

  function recordOpenerFromEventTarget(target) {
    if (!target) return;

    var opener =
      target.closest('button[type="submit"][name="add"], button[name="add"], [data-add-to-cart], .product-form__submit, form[action^="/cart/add"] button') ||
      target.closest('a[href="/cart"], a[href^="/cart?"], button[aria-label*="Cart"], button[aria-controls*="cart"], [data-cart-toggle], .js-cart-toggle');

    if (opener) lastCartOpener = opener;
  }

  document.addEventListener('click', function (e) {
    recordOpenerFromEventTarget(e.target);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    recordOpenerFromEventTarget(e.target);
  }, true);


  if (!document || !document.addEventListener) return;

  var selectorDrawer = 'cart-drawer[role="dialog"][data-name="cart-drawer"]';
  var activeDrawer = null;
  // var openerEl = null;
  var enabled = false;

  function isDrawerOpen(drawer) {
    if (!drawer) return false;
    if (drawer.getAttribute('aria-hidden') === 'true') return false;
    if (drawer.hasAttribute('open')) return true;
    return false;
  }

  function getFocusable(drawer) {
    if (!drawer) return [];

    var focusables = drawer.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );

    var tabbables = [];

    for (var i = 0; i < focusables.length; i++) {
      var focusable = focusables[i];

      if (!focusable) continue;
      if (focusable.getAttribute('tabindex') === '-1') continue;
      if (focusable.closest('[aria-hidden="true"], [hidden]')) continue;
      if (focusable.closest('.cart-drawer__empty-content--hidden')) continue;

      tabbables.push(focusable);
    }

    return tabbables;
  }

  function getCloseButton(drawer) {
    if (!drawer) return null;
    return drawer.querySelector('button.js-close-drawer, button.drawer__close-btn');
  }

  function safeFocus(el) {
    if (!el || typeof el.focus !== 'function') return;
    if (isRedirectingFocus) return;
    isRedirectingFocus = true;
    el.focus();
    setTimeout(function () { isRedirectingFocus = false; }, 0);
  }


  function focusFirst(drawer) {
    var closeBtn = getCloseButton(drawer);
    if (closeBtn) {
      closeBtn.focus();
      return true;
    }
    var focusables = getFocusable(drawer);
    if (focusables.length) {
      focusables[0].focus();
      return true;
    }
    if (drawer && typeof drawer.focus === 'function') {
      drawer.focus();
      return true;
    }
    return false;
  }

  function enableTrap(drawer) {
    if (enabled) return;
    enabled = true;
    activeDrawer = drawer;
    document.addEventListener('keydown', onKeydown, true);
    document.addEventListener('focusin', onFocusIn, true);
  }

  function disableTrap() {
    if (!enabled) return;
    enabled = false;
    document.removeEventListener('keydown', onKeydown, true);
    document.removeEventListener('focusin', onFocusIn, true);
    activeDrawer = null;
  }

  function onKeydown(e) {
    if (!enabled || !activeDrawer) return;
    if (!isDrawerOpen(activeDrawer)) return;

    if (e.key !== 'Tab') return;

    var closeBtn = getCloseButton(activeDrawer);

    var emptyContainer = activeDrawer.querySelector('.cart-drawer__empty-content:not(.cart-drawer__empty-content--hidden)');

    var emptyFirst = null;
    var emptyLast = null;

    if (emptyContainer) {
      var emptyFocusables = emptyContainer.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (emptyFocusables.length) {
        emptyFirst = emptyFocusables[0];
        emptyLast = emptyFocusables[emptyFocusables.length - 1];
      }
    }

    var emptyLast = null;
    if (emptyContainer) {
      var emptyFocusables = emptyContainer.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (emptyFocusables.length) emptyLast = emptyFocusables[emptyFocusables.length - 1];
    }

    var focusables = getFocusable(activeDrawer);
    if (!focusables.length) return;

    var first = emptyFirst || closeBtn || focusables[0];
    var last = emptyLast || focusables[focusables.length - 1]; // get the actual last focusable item in this container

    var current = document.activeElement; 
    var currentIndex = focusables.indexOf(current);

    if (e.shiftKey) {
      if (current === first || currentIndex === 0) {
        e.preventDefault();
        safeFocus(last);
      }
      return;
    }

    if (current === last || currentIndex === focusables.length - 1) {
      e.preventDefault();
      safeFocus(first);
    }
  }


  function onFocusIn(e) {
    if (!enabled || !activeDrawer) return;
    if (!isDrawerOpen(activeDrawer)) return;

    if (isRedirectingFocus) return;

    var target = e.target;
    if (!target) return;

    if (activeDrawer.contains(target)) return;

    var first = getCloseButton(activeDrawer) || getFocusable(activeDrawer)[0];
    safeFocus(first);
  }

  function onOpen(drawer) {
    // openerEl = document.activeElement;
    enableTrap(drawer);
    setTimeout(function () {
      if (!isDrawerOpen(drawer)) return;
      focusFirst(drawer);
    }, 0);
  }

  function onClose() {
    disableTrap();

    var toFocus = isUsableFocusTarget(lastCartOpener) ? lastCartOpener : getCartIcon();
    lastCartOpener = null;
    // openerEl = null;

    if (isUsableFocusTarget(toFocus)) {
      setTimeout(function () {
        toFocus.focus();
      }, 0);
    }
  }

  function watch() {
    var drawer = document.querySelector(selectorDrawer);
    if (!drawer) return;

    var wasOpen = isDrawerOpen(drawer);

    var mo = new MutationObserver(function () {
      var isOpen = isDrawerOpen(drawer);

      if (!wasOpen && isOpen) onOpen(drawer);
      if (wasOpen && !isOpen) onClose();

      wasOpen = isOpen;
    });

    mo.observe(drawer, { attributes: true, attributeFilter: ['open', 'aria-hidden'] });

    if (isDrawerOpen(drawer)) {
      onOpen(drawer);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();

//*** COMBINED SEARCH EXPERIENCE FOCUS MANAGEMENT ***//
// Theme main-search banner + MZ predictive search (mz-autocomplete) act as one dialog.
(function () {
  if (window.__a11ySearchFocusInstalled) return;
  window.__a11ySearchFocusInstalled = true;

  var searchOpener = null;
  var trapEnabled = false;
  var isRedirectingFocus = false;

  var FOCUSABLE_SELECTOR =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function isSearchOpen() {
    return document.body.classList.contains('show-search');
  }

  function getMainSearch() {
    return document.querySelector('main-search.main-search, .section-header .main-search');
  }

  function canFocus(el) {
    if (!el || typeof el.focus !== 'function') return false;
    if (!document.contains(el)) return false;
    if (el.hasAttribute('disabled')) return false;
    if (el.closest('[aria-hidden="true"], [hidden]')) return false;

    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;

    return true;
  }

  function getFocusablesIn(root) {
    if (!root) return [];

    var candidates = root.querySelectorAll(FOCUSABLE_SELECTOR);
    var focusables = [];

    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (!canFocus(el)) continue;
      if (el.getAttribute('tabindex') === '-1') continue;
      focusables.push(el);
    }

    return focusables;
  }

  function isMzAutocompleteVisible() {
    var container = document.querySelector('#mz-autocomplete .mz-autocomplete-container');
    if (!container) return false;

    var style = window.getComputedStyle(container);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function getOrderedSearchFocusables() {
    var mainSearch = getMainSearch();
    if (!mainSearch) return [];

    var ordered = [];
    var seen = {};

    function add(el) {
      if (!el || seen[el]) return;
      seen[el] = true;
      ordered.push(el);
    }

    var input = mainSearch.querySelector('.main-search__input');
    var submit = mainSearch.querySelector('.main-search__button');

    add(canFocus(input) ? input : null);
    add(canFocus(submit) ? submit : null);

    if (isMzAutocompleteVisible()) {
      var mzContainer = document.querySelector('#mz-autocomplete .mz-autocomplete-container');
      getFocusablesIn(mzContainer).forEach(add);
    }

    var closeBtn = mainSearch.querySelector('.main-search__close');
    add(canFocus(closeBtn) ? closeBtn : null);

    getFocusablesIn(mainSearch).forEach(add);

    return ordered;
  }

  function isInSearchExperience(el) {
    if (!el) return false;

    var mainSearch = getMainSearch();
    if (mainSearch && mainSearch.contains(el)) return true;

    return !!el.closest('#mz-autocomplete .mz-autocomplete-container');
  }

  function recordOpener(target) {
    if (!target || !target.closest) return;

    var opener = target.closest('.show-search-link');
    if (opener) searchOpener = opener;
  }

  function getOpenerToFocus() {
    if (canFocus(searchOpener)) return searchOpener;

    var link = document.querySelector('.show-search-link');
    if (canFocus(link)) return link;

    return null;
  }

  function safeFocus(el) {
    if (!canFocus(el)) return;

    isRedirectingFocus = true;
    el.focus({ preventScroll: true });
    isRedirectingFocus = false;
  }

  function closeSearchExperience() {
    if (!isSearchOpen()) return;

    var closeBtn = getMainSearch() && getMainSearch().querySelector('.main-search__close');
    if (closeBtn) {
      closeBtn.click();
      return;
    }

    document.body.classList.remove('show-search');
  }

  function enableTrap() {
    if (trapEnabled) return;
    trapEnabled = true;
    document.addEventListener('keydown', onKeydown, true);
    document.addEventListener('focusin', onFocusIn, true);
  }

  function disableTrap() {
    if (!trapEnabled) return;
    trapEnabled = false;
    document.removeEventListener('keydown', onKeydown, true);
    document.removeEventListener('focusin', onFocusIn, true);
  }

  function onKeydown(e) {
    if (!trapEnabled || !isSearchOpen()) return;

    if (e.key === 'Escape') {
      e.preventDefault();
      e.stopPropagation();
      closeSearchExperience();
      return;
    }

    if (e.key !== 'Tab') return;

    var focusables = getOrderedSearchFocusables();
    if (!focusables.length) return;

    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    var current = document.activeElement;

    if (e.shiftKey) {
      if (current === first || focusables.indexOf(current) === -1) {
        e.preventDefault();
        safeFocus(last);
      }
      return;
    }

    if (current === last) {
      e.preventDefault();
      safeFocus(first);
    }
  }

  function onFocusIn(e) {
    if (!trapEnabled || !isSearchOpen()) return;
    if (isRedirectingFocus) return;

    var target = e.target;
    if (!target || isInSearchExperience(target)) return;

    var focusables = getOrderedSearchFocusables();
    if (!focusables.length) return;

    safeFocus(focusables[0]);
  }

  function onSearchOpen() {
    enableTrap();
  }

  function onSearchClose() {
    disableTrap();

    var toFocus = getOpenerToFocus();
    searchOpener = null;

    if (toFocus) {
      setTimeout(function () {
        safeFocus(toFocus);
      }, 0);
    }
  }

  document.addEventListener('click', function (e) {
    recordOpener(e.target);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    recordOpener(e.target);
  }, true);

  function watchSearchState() {
    var wasOpen = isSearchOpen();

    var mo = new MutationObserver(function () {
      var isOpen = isSearchOpen();

      if (!wasOpen && isOpen) onSearchOpen();
      if (wasOpen && !isOpen) onSearchClose();

      wasOpen = isOpen;
    });

    mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    if (wasOpen) onSearchOpen();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchSearchState);
  } else {
    watchSearchState();
  }
})();

//*** CART DRAWER CORSO CHECKOUT CLONE FOCUS FIX ***//
(function () {
  function fixCorsoCheckoutClone() {
    var original = document.querySelector(
      '.cart-drawer__footer a[data-corso-checkout-plus="original"][href]'
    );

    var clone = document.querySelector(
      '.cart-drawer__footer a[data-corso-checkout-plus="clone"]'
    );

    if (!original || !clone) return;

    if (!clone.hasAttribute('href')) {
      clone.setAttribute('href', original.getAttribute('href'));
    }
  }

  fixCorsoCheckoutClone();

  new MutationObserver(fixCorsoCheckoutClone).observe(document.body, {
    childList: true,
    subtree: true
  });
})();

//*** CART COUNT SCREEN READER ANNOUNCEMENT ***//
(function () {
  if (window.__a11yCartCountAnnouncementInstalled) return;
  window.__a11yCartCountAnnouncementInstalled = true;

  var drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  function createStatus(id, parent) {
    var existing = document.getElementById(id);
    if (existing) return existing;

    var status = document.createElement('div');
    status.id = id;
    status.className = 'visually-hidden';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');

    parent.appendChild(status);
    return status;
  }

  // Used when cart drawer is closed
  var globalStatus = createStatus(
    'a11y-cart-count-status',
    document.body
  );

  // Used when cart drawer is open
  var drawerStatus = createStatus(
    'a11y-cart-count-status-drawer',
    drawer
  );

  function getCartCount() {
    var countEl = drawer.querySelector('.cart-drawer__title-count');
    if (!countEl) return 0;

    var match = countEl.textContent.match(/\d+/);
    return match ? parseInt(match[0], 10) : 0;
  }

  function drawerIsOpen() {
    return (
      drawer.hasAttribute('open') &&
      drawer.getAttribute('aria-hidden') !== 'true'
    );
  }

  var lastCount = getCartCount();
  var pendingMessage = '';
  var timer = null;

  function announce(message, target) {
    clearTimeout(timer);

    timer = setTimeout(function () {
      globalStatus.textContent = '';
      drawerStatus.textContent = '';

      requestAnimationFrame(function () {
        target.textContent = message;
      });
    }, 350);
  }

  document.addEventListener('on:cart:after-merge', function () {
    var count = getCartCount();

    if (Number.isNaN(count) || count === lastCount) return;

    lastCount = count;

    var message =
      count === 1
        ? '1 item in cart'
        : count + ' items in cart';

    if (drawerIsOpen()) {
      announce(message, drawerStatus);
    } else {
      pendingMessage = message;

      // If the drawer does not open, announce globally.
      setTimeout(function () {
        if (!pendingMessage) return;

        if (drawerIsOpen()) {
          announce(pendingMessage, drawerStatus);
        } else {
          announce(pendingMessage, globalStatus);
        }

        pendingMessage = '';
      }, 100);
    }
  });

  // If Add to Cart opens the drawer, announce after
  // focus has moved into the drawer.
  new MutationObserver(function () {
    if (!pendingMessage || !drawerIsOpen()) return;

    var message = pendingMessage;
    pendingMessage = '';

    announce(message, drawerStatus);
  }).observe(drawer, {
    attributes: true,
    attributeFilter: ['open', 'aria-hidden']
  });
})();

//*** CART QUANTITY CONTROLS **//
  // Cart drawer and main cart: quantity decrease and increase
  // Quick buy: quantity decrease and increase 
(function () {
  const quantityControlSelector = `
    a.quantity-down,
    a.quantity-up,
    quantity-wrapper a[data-quantity]
  `;

  function isQuantityControl(element) {
    return element && element.matches(quantityControlSelector);
  }

  function ensureButtonRole(element) {
    if (element.getAttribute('role') !== 'button') {
      element.setAttribute('role', 'button');
    }
  }

  function isSpaceKey(event) {
    return event.key === ' ' || event.code === 'Space';
  }

  document.addEventListener('keydown', function (keyboardEvent) {
    if (!isSpaceKey(keyboardEvent)) return;

    const quantityControl =
      keyboardEvent.target &&
      keyboardEvent.target.closest &&
      keyboardEvent.target.closest(quantityControlSelector);

    if (!isQuantityControl(quantityControl)) return;

    ensureButtonRole(quantityControl);

    keyboardEvent.preventDefault();

    if (quantityControl.classList.contains('unusable')) return;

    quantityControl.click();
  });

  document.querySelectorAll(quantityControlSelector).forEach(ensureButtonRole);
})();
  
//*** SIZE GUIDE MODAL FOCUS MANAGEMENT **//
// On open: focus Close (X)
// On close: return focus to the Size Guide trigger
(function () {
  var sizeGuideTrigger = null;
  var sizeGuideModalId = null;
  var boundModalIds = {};

  function modalIsOpen(modal) {
    if (!modal) return false;
    if (modal.getAttribute('aria-hidden') === 'true') return false;
    return modal.hasAttribute('open');
  }

  function canReceiveFocus(el) {
    if (!el) return false;
    if (typeof el.focus !== 'function') return false;
    if (!document.contains(el)) return false;
    if (el.closest('[aria-hidden="true"]')) return false;
    if (el.hasAttribute('disabled')) return false;
    return true;
  }

  function rememberSizeGuideTrigger(target) {
    if (!target || !target.closest) return;

    var sizeGuideButton = target.closest('button.size-chart-link');
    if (!sizeGuideButton) return;

    var opener = sizeGuideButton.closest('modal-opener[data-modal^="size-chart-"]');
    if (!opener) return;

    sizeGuideModalId = opener.getAttribute('data-modal');
    sizeGuideTrigger = sizeGuideButton;
  }

  document.addEventListener('click', function (e) {
    rememberSizeGuideTrigger(e.target);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    rememberSizeGuideTrigger(e.target);
  }, true);

  function focusCloseButton(modal) {
    var closeButton = modal && modal.querySelector('button.modal__close-btn');
    if (canReceiveFocus(closeButton)) closeButton.focus();
  }

  function findTriggerForModalId(modalId) {
    if (!modalId) return null;
    var opener = document.querySelector('modal-opener[data-modal="' + modalId + '"]');
    if (!opener) return null;
    return opener.querySelector('button.size-chart-link') || opener;
  }

  function returnFocusToTrigger() {
    var freshTrigger = findTriggerForModalId(sizeGuideModalId);

    var target =
      (canReceiveFocus(freshTrigger) && freshTrigger) ||
      (canReceiveFocus(sizeGuideTrigger) && sizeGuideTrigger) ||
      null;

    sizeGuideTrigger = null;
    sizeGuideModalId = null;

    if (target) target.focus();
  }

  function watchSizeChartModal(modal) {
    var id = modal && modal.id;
    if (!id || boundModalIds[id]) return;
    boundModalIds[id] = true;

    var previouslyOpen = modalIsOpen(modal);

    new MutationObserver(function () {
      var currentlyOpen = modalIsOpen(modal);

      if (!previouslyOpen && currentlyOpen) {
        setTimeout(function () { focusCloseButton(modal); }, 0);
        setTimeout(function () { focusCloseButton(modal); }, 50);
      }

      if (previouslyOpen && !currentlyOpen) {
        setTimeout(function () { returnFocusToTrigger(); }, 50);
      }

      previouslyOpen = currentlyOpen;
    }).observe(modal, { attributes: true, attributeFilter: ['open', 'aria-hidden'] });
  }

  function bindExistingSizeChartModals(root) {
    var scope = root || document;
    var modals = scope.querySelectorAll('modal-dialog[id^="size-chart-"][role="dialog"][aria-modal="true"]');
    for (var i = 0; i < modals.length; i++) watchSizeChartModal(modals[i]);
  }

  function observeQuickBuyInner(inner) {
    if (!inner || inner.__a11yObserved) return;
    inner.__a11yObserved = true;

    bindExistingSizeChartModals(inner);

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        if (!added) continue;

        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (!node || node.nodeType !== 1) continue;

          if (node.matches && node.matches('modal-dialog[id^="size-chart-"][role="dialog"][aria-modal="true"]')) {
            watchSizeChartModal(node);
          }

          if (node.querySelectorAll) {
            var innerModals = node.querySelectorAll('modal-dialog[id^="size-chart-"][role="dialog"][aria-modal="true"]');
            for (var k = 0; k < innerModals.length; k++) watchSizeChartModal(innerModals[k]);
          }
        }
      }
    }).observe(inner, { childList: true, subtree: true });
  }

  function init() {
    bindExistingSizeChartModals(document);

    document.querySelectorAll('.quickbuy-container > .inner').forEach(observeQuickBuyInner);

    new MutationObserver(function () {
      document.querySelectorAll('.quickbuy-container > .inner').forEach(observeQuickBuyInner);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();


//*** COOKIE BANNER: POST RENDER ADJUSTMENT (acceptable to auditor) **//
(function () {
  if (!document || !document.querySelector) return;

  function updateCookieBannerRole() {
    const host = document.querySelector('.csm-cookie-consent');
    if (!host || !host.shadowRoot) return false;

    const banner = host.shadowRoot.querySelector(
      '[aria-label="cookie bar"][role="dialog"]'
    );

    if (!banner) return false;

    banner.setAttribute('role', 'region');
    banner.removeAttribute('aria-modal'); 
    
    return true;
  }

  if (updateCookieBannerRole()) return;

  const observer = new MutationObserver(function () {
    if (updateCookieBannerRole()) observer.disconnect();

  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();

//*** QUICK BUY DRAWER FOCUS MANAGEMENT (COLLECTION CAROUSEL) ***//
(function () {

  // prevent double install
  if (window.__a11yQuickBuyFocusInstalled) return;
  window.__a11yQuickBuyFocusInstalled = true;

  // store the last quick buy button that opened a drawer
  var lastQuickBuyOpener = null;

  // check if element is a quick buy toggle
  function isQuickBuyOpener(element) {
    return !!(element && element.closest && element.closest('a.quickbuy-toggle'));
  }

  // get the quick buy opener from an event target
  function getOpenerFromEventTarget(target) {
    if (!target || !target.closest) return null;
    return target.closest('a.quickbuy-toggle');
  }

  // remember which quick buy opened the drawer
  function rememberOpener(target) {
    var opener = getOpenerFromEventTarget(target);
    if (!opener) return;
    lastQuickBuyOpener = opener;
  }

  // remember opener on mouse click
  document.addEventListener('click', function (event) {
    if (isQuickBuyOpener(event.target)) {
      rememberOpener(event.target);
    }
  }, true);

  // remember opener on enter or space
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    if (isQuickBuyOpener(event.target)) {
      rememberOpener(event.target);
    }
  }, true);

  // ESC closes quick buy
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    var containers = document.querySelectorAll('.quickbuy-container');

    for (var i = 0; i < containers.length; i++) {
      var container = containers[i];

      if (!containerIsOpen(container)) continue;

      var closeControl = container.querySelector('a.close-detail, button.close-detail, [data-close]');
      if (!closeControl) continue;

      closeControl.click();
    }
  }, true);

  // SPACE key funcs
  function isSpaceKey(event) {
    return event.key === ' ' || event.code === 'Space';
  }

  function isEnterKey(event) {
    return event.key === 'Enter';
  }

  function isQuickBuyCloseControl(target) {
    if (!target || !target.closest) return false;
    // return !!target.closest('.quickbuy-container a.close-detail[role="button"]');

    return !!target.closest(
      '.quickbuy-container a.close-detail, .quickbuy-container button.close-detail, .quickbuy-container [data-close]'
    );
  }

  document.addEventListener('keydown', function (event) {
    if (!isSpaceKey(event) && !isEnterKey(event)) return;

    if (!isQuickBuyCloseControl(event.target)) return;

    event.preventDefault();

    var closeControl = event.target.closest(
      '.quickbuy-container a.close-detail, .quickbuy-container button.close-detail, .quickbuy-container [data-close]'
    );
    if (closeControl) closeControl.click();
  }, true);
  

  // check if drawer is currently open
  function containerIsOpen(container) {
    if (!container) return false;

    var rect = container.getBoundingClientRect();
    if (rect.height <= 1) return false;

    var computedStyle = window.getComputedStyle(container);
    if (computedStyle.display === 'none') return false;
    if (computedStyle.visibility === 'hidden') return false;

    return true;
  }

  // move focus to the close button when drawer opens
  function focusClose(container) {
    if (!container) return;

    var closeControl = container.querySelector('a.close-detail, button.close-detail, [data-close]');
    if (!closeControl || typeof closeControl.focus !== 'function') return;

    closeControl.focus();

    // retry once in case theme overrides focus
    setTimeout(function () {
      if (document.activeElement !== closeControl) {
        closeControl.focus();
      }
    }, 50);
  }

  // restore focus to the original quick buy button
  function ensureOpenerVisibleAndFocus(opener) {
    if (!opener || typeof opener.focus !== 'function') return;
    if (!document.contains(opener)) return;

    var imageContainer = opener.closest('.image-cont');
    if (imageContainer) {
      imageContainer.classList.add('a11y-quickbuy-force-open');
    }

    opener.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    opener.focus({ preventScroll: true });

    // remove temporary visibility class
    setTimeout(function () {
      if (imageContainer) {
        imageContainer.classList.remove('a11y-quickbuy-force-open');
      }
    }, 250);
  }

  // handle drawer close
  function onClose() {
    if (!lastQuickBuyOpener) return;

    var opener = lastQuickBuyOpener;
    lastQuickBuyOpener = null;

    setTimeout(function () {
      ensureOpenerVisibleAndFocus(opener);
    }, 0);
  }

  // show/hide quickbuy region from screenreaders
  function showHideFromScreenReader(container, isOpen) {
    if (!container) return;

    var closeControl = container.querySelector(
      'a.close-detail, button.close-detail, [data-close]'
    );

    if (isOpen) {
      if (container.hasAttribute('aria-hidden')) {
        container.removeAttribute('aria-hidden');
      }

      if (closeControl) {
        closeControl.removeAttribute('tabindex');
      }
    } else {
      if (container.getAttribute('aria-hidden') !== 'true') {
        container.setAttribute('aria-hidden', 'true');
      }

      if (closeControl) {
        closeControl.setAttribute('tabindex', '-1');
      }
    }
  }

  // bind focus logic to each quick buy container
  function bindContainer(container) {
    if (!container || container.__a11yQuickBuyFocusBound) return;
    container.__a11yQuickBuyFocusBound = true;

    var wasOpen = containerIsOpen(container);
    // set initial screen reader visibility
    showHideFromScreenReader(container, wasOpen);

    // observe only this container for open/close state changes
    new MutationObserver(function () {
      var isOpenNow = containerIsOpen(container);
      // update screen reader visibility when drawer changes
      showHideFromScreenReader(container, isOpenNow);

      if (!wasOpen && isOpenNow) {
        focusClose(container);
      }

      if (wasOpen && !isOpenNow) {
        onClose();
      }

      wasOpen = isOpenNow;
    }).observe(container, {
      attributes: true,
      attributeFilter: ['class', 'style', 'open', 'aria-hidden']
    });

    // sync state after height transition
    container.addEventListener('transitionend', function (event) {
      if (event.target !== container || event.propertyName !== 'height') return;

      var isOpenNow = containerIsOpen(container);
      showHideFromScreenReader(container, isOpenNow);

      if (!wasOpen && isOpenNow) {
        focusClose(container);
      }

      if (wasOpen && !isOpenNow) {
        onClose();
      }

      wasOpen = isOpenNow;
    });

    // if already open at bind time, focus close
    if (wasOpen) {
      focusClose(container);
    }
  }

  // initialize focus management for existing quick buy containers
  function init() {
    var containers = document.querySelectorAll('.quickbuy-container');
    for (var i = 0; i < containers.length; i++) {
      bindContainer(containers[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

//*** MOBILE QUICK BUY MODAL FOCUS MANAGEMENT ***//
// On open:
// - moves focus to the Close button
// - contains Tab and Shift+Tab within the modal
// - prevents focus from escaping the open modal
//
// On close:
// - returns focus to the exact mobile quick buy button that opened it
(function () {
  if (window.__a11yMobileQuickBuyInstalled) return;
  window.__a11yMobileQuickBuyInstalled = true;

  var sheet = document.getElementById('mobile-size-sheet');
  if (!sheet) return;

  var opener = null;
  var wasOpen = false;

  var focusableSelector =
    'a[href], button:not([disabled]), input:not([disabled]), ' +
    'select:not([disabled]), textarea:not([disabled]), ' +
    '[tabindex]:not([tabindex="-1"])';

  function isOpen() {
    return sheet.getAttribute('aria-hidden') === 'false' &&
      !sheet.hasAttribute('inert');
  }

  function getFocusable() {
    return Array.from(sheet.querySelectorAll(focusableSelector)).filter(function (element) {
      return !element.closest('[hidden], [aria-hidden="true"], [inert]') &&
        element.offsetParent !== null;
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest(
      'button.mobile-quick-buy-btn[data-open-size-sheet]'
    );

    if (trigger) opener = trigger;
  }, true);

  document.addEventListener('keydown', function (event) {
    if (!isOpen() || event.key !== 'Tab') return;

    var focusable = getFocusable();
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }, true);

  document.addEventListener('focusin', function (event) {
    if (!isOpen() || sheet.contains(event.target)) return;

    var closeButton = sheet.querySelector('[data-close-sheet]');
    if (closeButton) closeButton.focus();
  }, true);

  new MutationObserver(function () {
    var openNow = isOpen();

    if (!wasOpen && openNow) {
      var closeButton = sheet.querySelector('[data-close-sheet]');
      if (closeButton) {
        setTimeout(function () {
          closeButton.focus();
        }, 0);
      }
    }

    if (wasOpen && !openNow && opener && document.contains(opener)) {
      var triggerToRestore = opener;
      opener = null;

      setTimeout(function () {
        triggerToRestore.focus();
      }, 0);
    }

    wasOpen = openNow;
  }).observe(sheet, {
    attributes: true,
    attributeFilter: ['aria-hidden', 'inert']
  });
})();

//*** PRODUCT GRID CAROUSEL: HIDE NON-ACTIVE TILE IMAGES FROM SCREEN READERS **//
// only expose the active tile image, so screen reader can move past the image to quick buy
(function () {
  if (window.__a11yCarouselTileImagesInstalled) return;
  window.__a11yCarouselTileImagesInstalled = true;

  function updateTileImages() {
    var tiles = document.querySelectorAll('.product-grid--carousel .product-block');

    for (var i = 0; i < tiles.length; i++) {
      var tile = tiles[i];
      var imageWraps = tile.querySelectorAll('.product-block__image');

      for (var j = 0; j < imageWraps.length; j++) {
        var wrap = imageWraps[j];
        var isActive = wrap.classList.contains('product-block__image--active');

        if (isActive) {
          wrap.removeAttribute('aria-hidden');
        } else {
          wrap.setAttribute('aria-hidden', 'true');
        }
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateTileImages);
  } else {
    updateTileImages();
  }
})();

//*** WISHLIST CART **//
// enable space key activation for header controls that behave like buttons
document.addEventListener('keydown', function (event) {
  if (event.key !== ' ') return;

  var elem = null;
  var target = event.target;

  if (target && typeof target.closest === 'function') {
    elem = target.closest(
      'a.show-search-link[role="button"], a.cart-link[role="button"]'
    );
  }

  if (!elem) return;

  event.preventDefault();
  elem.click();
});

//*** WISHLIST **//
const initWishlistA11y = () => {
  const wishlistLinkElem =
    document.querySelector('.wishlist-hero-header-icon');

  const wishlistCountElem =
    wishlistLinkElem?.querySelector('.wishlist-hero-items-count');

  if (!wishlistLinkElem || !wishlistCountElem) return false;

  const updateWishlistLabel = () => {
    const isHidden =
      wishlistCountElem.style.display === 'none' ||
      !wishlistCountElem.classList.contains('wishlist-hero-items-count-exists');

    /// when wishlist becomes empty, the app hides the count badge instead of clearing its text content.
     // treat the hidden state as "empty" for the link's accessible name.
    if (isHidden) {
      wishlistLinkElem.setAttribute('aria-label', 'Wishlist, empty');
      return;
    }

    const countText = wishlistCountElem.textContent.trim();
    const itemCount = countText === '' ? 0 : Number(countText);

    const label =
      itemCount === 1
        ? 'Wishlist, 1 item'
        : `Wishlist, ${itemCount} items`;

    wishlistLinkElem.setAttribute('aria-label', label);
  };

  updateWishlistLabel();

  new MutationObserver(updateWishlistLabel).observe(
    wishlistCountElem,
      {
        attributes: true,
        attributeFilter: ['class', 'style'],
        childList: true,
        characterData: true,
        subtree: true
      }
  );

  return true;
};

if (!initWishlistA11y()) {
  const wishlistInitObserver = new MutationObserver(() => {
    if (initWishlistA11y()) {
      wishlistInitObserver.disconnect();
    }
  });

  wishlistInitObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
}

// ** AFTERPAY LOGO ACCESSIBILITY ** //
// keyboard access to Afterpay modal trigger while preserving existing image click handling.
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.afterpay-logo-button');
  if (!btn) return;

  const img = btn.querySelector('[data-afterpay-modal]');
  if (img && e.target !== img) img.click();
});

// ** FOOTER PAYMENT ICON SVG LABELS ** //
// Shopify renders these payment SVGs inline
// add aria-label post render and remove aria-labelledby
// leave one clean accessible name
(function () {
  if (window.__a11yPaymentIconsFixed) return;
  window.__a11yPaymentIconsFixed = true;

  document.addEventListener('DOMContentLoaded', function () {

    var toTitleCase = function (text) {
      var lowerWords = ['and', 'or', 'the', 'of', 'to', 'in', 'on', 'for'];

      return text
        .split(' ')
        .map(function (word, index) {
          var lower = word.toLowerCase();
          if (index !== 0 && lowerWords.indexOf(lower) !== -1) {
            return lower;
          }
          return lower.charAt(0).toUpperCase() + lower.slice(1);
        })
        .join(' ');
    };

    var paymentSvgs = document.querySelectorAll('.section-footer__payment-icon');

    paymentSvgs.forEach(function (svg) {
      var labelledBy = svg.getAttribute('aria-labelledby');
      if (!labelledBy) return;

      var labelText = labelledBy
        .replace(/^pi-/, '')
        .replace(/_/g, ' ')
        .trim();

      if (labelText === 'master') {
        labelText = 'Mastercard';
      } else if (labelText === 'paypal') {
        labelText = 'PayPal';
      } else {
        labelText = toTitleCase(labelText);
      }

      svg.setAttribute('aria-label', labelText);
      svg.removeAttribute('aria-labelledby');
    });

  });
})();

// ** TEMP: REMOVE NOSTO MOBILE MENU CAROUSEL ** //
// This placement is being removed in Nosto. Until then, remove it from the mobile menu.
(function () {
  function removeNostoMobileMenuCarousel() {
    var nostoMobileMenuCarousel = document.querySelector(
      '.mobile-navigation-drawer #nosto-mobilemenu-replace'
    );

    if (!nostoMobileMenuCarousel) return;

    nostoMobileMenuCarousel.remove();
  }

  removeNostoMobileMenuCarousel();

  new MutationObserver(removeNostoMobileMenuCarousel).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();

// ** NOSTO INJECTION HEADING FIX ** // 
(function () {

  function fixHeading() {
    var container = document.getElementById('nosto-mobilemenu-replace');
    if (!container) return;

    var h1 = container.querySelector('h1.hometitle');
    if (!h1) return;

    var h2 = document.createElement('h2');

    while (h1.firstChild) {
      h2.appendChild(h1.firstChild);
    }

    for (var i = 0; i < h1.attributes.length; i++) {
      var attr = h1.attributes[i];
      h2.setAttribute(attr.name, attr.value);
    }

    h1.parentNode.replaceChild(h2, h1);
  }

  fixHeading();

  if (!window.MutationObserver) return;

  new MutationObserver(fixHeading).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

})();

// ** EASYSLIDER ACCORDION H2 WRAPPER (PRODUCT ONLY) ** //
(function () {
  if (window.__a11yEasySliderHeadingWrapperInstalled) return;
  window.__a11yEasySliderHeadingWrapperInstalled = true;

  if (
    !document.body.classList.contains('template-product') &&
    !window.location.pathname.includes('/products/')
  ) return;

  function wrapEasySliderHeaders() {
    document.querySelectorAll('.easyslider-header[role="button"]').forEach(function (header) {
      var h2;

      if (header.dataset.a11yActivationFix !== 'true') {
        header.dataset.a11yActivationFix = 'true';

        header.addEventListener('click', function (e) {
          if (e.target !== header) return;

          var anchor = header.querySelector('.easyslider-anchor');

          if (!anchor) return;

          e.preventDefault();
          e.stopPropagation();

          anchor.click();
        });
      }

      if (header.parentElement && header.parentElement.classList.contains('a11y-easyslider-heading')) return;

      h2 = document.createElement('h2');
      h2.className = 'a11y-easyslider-heading';
      h2.style.margin = '0';

      header.parentNode.insertBefore(h2, header);
      h2.appendChild(header);
    });
  }

  wrapEasySliderHeaders();

  var mo = new MutationObserver(wrapEasySliderHeaders);

  mo.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
 

// ** PRODUCT DETAIL CAROUSEL TABINDEX CONTROL (PDP and Quick Buy drawer) ** //
  // Keeps non-active product media slides out of the tab order.
  // When a slide is not .is-active, set aria-hidden="true" on the slide and set tabindex="-1" on focusable elements inside it.
  // When the slide becomes active again, restore each element’s previous tabindex value (only if it was changed by this script).
(function () {
  if (window.__a11yProductGallerySlideA11yInstalled) return;
  window.__a11yProductGallerySlideA11yInstalled = true;

  // var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]';
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled])';
  var PREV_TAB = 'data-a11y-prev-tabindex';
  var OWN_HIDDEN = 'data-a11y-slide-hidden';

  function setHidden(slide) {
    if (!slide) return;

    slide.setAttribute(OWN_HIDDEN, 'true');
    slide.setAttribute('aria-hidden', 'true');

    var nodes = slide.querySelectorAll(FOCUSABLE);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (!el || !el.getAttribute) continue;

      if (!el.hasAttribute(PREV_TAB)) {
        var prev = el.getAttribute('tabindex');
        el.setAttribute(PREV_TAB, prev === null ? '' : prev);
      }
      el.setAttribute('tabindex', '-1');
    }

    // REMOVE tabindex from the slide itself if it exists
    if (slide.hasAttribute('tabindex')) {
      slide.removeAttribute('tabindex');
    }
  }

  function setVisible(slide) {
    if (!slide) return;

    if (slide.getAttribute(OWN_HIDDEN) === 'true') {
      slide.removeAttribute(OWN_HIDDEN);
      slide.removeAttribute('aria-hidden');

      var nodes = slide.querySelectorAll('[' + PREV_TAB + ']');
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        var prev = el.getAttribute(PREV_TAB);
        el.removeAttribute(PREV_TAB);
        if (prev === '') el.removeAttribute('tabindex');
        else el.setAttribute('tabindex', prev);
      }
    }
  }

  function updateSlider(sliderRoot) {
    if (!sliderRoot) return;

    var slides = sliderRoot.querySelectorAll('.slider__grid > .slider__item');
    for (var i = 0; i < slides.length; i++) {
      var slide = slides[i];
      var active = slide.classList && slide.classList.contains('is-active');
      if (active) setVisible(slide);
      else setHidden(slide);
    }
  }

  function bindSlider(sliderRoot) {
    
    if (!sliderRoot || sliderRoot.__a11yBound) return;
    sliderRoot.__a11yBound = true;

    var raf = 0;
    function schedule() {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        updateSlider(sliderRoot);
      });
    }

    schedule();

    var mo = new MutationObserver(schedule);
    mo.observe(sliderRoot, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  function init() {
    var galleries = document.querySelectorAll('media-gallery .main-image .slider[id^="slider-"]');

    for (var i = 0; i < galleries.length; i++) {
      bindSlider(galleries[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('on:quickbuy:after-open', function () {
    init();
  });
})();


// ** PRODUCT DETAIL CAROUSEL ARIA-HIDDEN SYNC (PDP and Quick Buy drawer) ** //
// keep aria-hidden in sync on pdp gallery slides
(function () {
  if (window.__a11yPdpGalleryAriaHiddenInstalled) return;
  window.__a11yPdpGalleryAriaHiddenInstalled = true;

  function updatePdpGalleryAriaHidden(sliderRoot) {
    if (!sliderRoot) return;

    var slides = sliderRoot.querySelectorAll('.slider__grid > .slider__item');

    for (var i = 0; i < slides.length; i++) {
      var slide = slides[i];
      var isActive = slide.classList && slide.classList.contains('is-active');

      if (isActive) {
        slide.removeAttribute('aria-hidden');
      } else {
        slide.setAttribute('aria-hidden', 'true');
      }
    }
  }

  function bindPdpGallery(sliderRoot) {
    if (!sliderRoot || sliderRoot.__a11yPdpAriaHiddenBound) return;
    sliderRoot.__a11yPdpAriaHiddenBound = true;

    var raf = 0;

    function schedule() {
      if (raf) return;

      raf = requestAnimationFrame(function () {
        raf = 0;
        updatePdpGalleryAriaHidden(sliderRoot);
      });
    }

    schedule();

    var mo = new MutationObserver(schedule);
    mo.observe(sliderRoot, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  function init() {
    var galleries = document.querySelectorAll('media-gallery .main-image .slider[id^="slider-"]');

    for (var i = 0; i < galleries.length; i++) {
      bindPdpGallery(galleries[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('on:quickbuy:after-open', function () {
    init();
  });
})();

//*** QUICK BUY TOGGLE SPACE KEY SUPPORT ***//
// for quick Buy buttons on product blocks that open a product detail drawer
(function () {
  function enableQuickBuyToggleSpaceKey() {
    document.querySelectorAll('a.quickbuy-toggle').forEach(function (toggle) {
      if (toggle.dataset.a11ySpaceKeyEnabled === 'true') return;

      toggle.dataset.a11ySpaceKeyEnabled = 'true';

      toggle.addEventListener('keydown', function (event) {
        if (event.key !== ' ') return;

        event.preventDefault();
        toggle.click();
      });
    });
  }

  enableQuickBuyToggleSpaceKey();

  document.addEventListener('shopify:section:load', enableQuickBuyToggleSpaceKey);
})();
 
//*** PRODUCT BLOCK IMAGES: HIDE NON-ACTIVE IMAGES FROM SCREEN READERS ***//
// applies to collection grids and product-card carousels
(function () {
  if (window.__a11yProductBlockImagesInstalled) return;
  window.__a11yProductBlockImagesInstalled = true;

  function updateProductBlockImageLabels(productBlock) {
    if (!productBlock) return;

    var imageCont = productBlock.querySelector('.image-cont');
    var primary = productBlock.querySelector('.product-block__image--primary');
    var primaryImg = primary ? primary.querySelector('img') : null;
    var instructions = imageCont ? imageCont.querySelector('.product-image-carousel-instructions') : null;
    var isDesktop = window.matchMedia('(min-width: 960px)').matches;

    if (imageCont) {
      if (isDesktop) {
        imageCont.setAttribute('role', 'region');
        imageCont.setAttribute('aria-label', imageCont.getAttribute('data-a11y-carousel-label') || '');
        if (instructions) {
          instructions.removeAttribute('aria-hidden');
        }
      } else {
        imageCont.removeAttribute('role');
        imageCont.removeAttribute('aria-label');
        if (instructions) {
          instructions.setAttribute('aria-hidden', 'true');
        }
      }
    }

    if (primary && primaryImg) {
      if (isDesktop) {
        primaryImg.setAttribute('alt', primary.getAttribute('data-a11y-carousel-alt') || '');
      } else {
        primaryImg.setAttribute('alt', primary.getAttribute('data-a11y-default-alt') || '');
      }
    }
  }

  function updateProductBlockImages(productBlock) {
    if (!productBlock) return;

    updateProductBlockImageLabels(productBlock);

    var wraps = productBlock.querySelectorAll('.product-block__image');
    if (!wraps.length) return;

    var active = productBlock.querySelector('.product-block__image--active');
    var imageCont = productBlock.querySelector('.image-cont');
    var primary = productBlock.querySelector('.product-block__image--primary');
    var hoverImage = productBlock.querySelector('.product-block__image--show-on-hover');

    // hover-image behavior only exists on desktop
    // allow the secondary hover image to remain readable before carousel interaction
    var hoverImageCanShow = window.matchMedia('(min-width: 960px)').matches;
    if (imageCont) {
      if (hoverImageCanShow) {
        imageCont.setAttribute('role', 'region');
        imageCont.setAttribute('aria-label', imageCont.getAttribute('data-a11y-carousel-label'));
      } else {
        imageCont.removeAttribute('role');
        imageCont.removeAttribute('aria-label');
      }
    }

        // // if viewport is too small for hover image behavior (< 960px),
        // // treat the primary image as the only readable image
        // var focusedProductImageLink = hoverImageCanShow
        //   ? productBlock.querySelector('.image-cont > a.product-link:focus')
        //   : null;

    // check if next/prev has been used
    var carouselWasUsed =
      imageCont &&
      imageCont.getAttribute('data-a11y-mini-carousel-used') === 'true';

    // check if carousel is back to the first image
    var backToInitialState =
      active &&
      primary &&
      active === primary;

    // reset to initial hover-image behavior when back at image 1
    if (imageCont && carouselWasUsed && backToInitialState) {
      imageCont.removeAttribute('data-a11y-mini-carousel-used');
      carouselWasUsed = false;
    }

    for (var i = 0; i < wraps.length; i++) {
      var wrap = wraps[i];

          // var isActive = active && wrap === active;
          // var isFocusedHoverImage =
          //   focusedProductImageLink &&
          //   wrap.classList.contains('product-block__image--show-on-hover');

      var isPrimary = primary && wrap === primary;
      var isHoverImage = hoverImage && wrap === hoverImage;
      var isActive = active && wrap === active;

            // // when keyboard focus reveals the hover image,
            // // make that image readable to screen readers
            // if (isFocusedHoverImage) {
            //   wrap.removeAttribute('aria-hidden');
            //   wrap.removeAttribute('tabindex');

            // // when no hover image is being shown,
            // // keep the default active image readable
            // } else if (isActive && !focusedProductImageLink) {
            //   wrap.removeAttribute('aria-hidden');
            //   wrap.removeAttribute('tabindex');

            // // hide all non-visible images from screen readers
            // } else {
            //   wrap.setAttribute('aria-hidden', 'true');
            //   wrap.setAttribute('tabindex', '-1');
            // }

      // before next/prev is used, keep image 1 readable
      // also keep image 2 readable when hover behavior exists
      if (
        !carouselWasUsed &&
        (
          isPrimary ||
          (hoverImageCanShow && isHoverImage)
        )
      ) {
        wrap.removeAttribute('aria-hidden');
        wrap.removeAttribute('tabindex');

      // after next/prev is used, only keep the active image readable
      } else if (carouselWasUsed && isActive) {
        wrap.removeAttribute('aria-hidden');
        wrap.removeAttribute('tabindex');

      // hide all other carousel images
      } else {
        wrap.setAttribute('aria-hidden', 'true');
        wrap.setAttribute('tabindex', '-1');
      }
    }
  }

  function bindProductBlock(productBlock) {
    if (!productBlock || productBlock.__a11yProductBlockImagesBound) return;
    productBlock.__a11yProductBlockImagesBound = true;

    updateProductBlockImages(productBlock);

    var mo = new MutationObserver(function () {
      updateProductBlockImages(productBlock);
    });

    mo.observe(productBlock, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class']
    });

    productBlock.addEventListener('click', function (event) {
      var button = event.target.closest('.image-page-button');
      if (!button) return;

      var imageCont = button.closest('.image-cont');
      if (!imageCont) return;

      imageCont.setAttribute('data-a11y-mini-carousel-used', 'true');

      setTimeout(function () {
        updateProductBlockImages(productBlock);
      }, 0);
    });

     productBlock.addEventListener('focusin', function () {
      updateProductBlockImages(productBlock);
    });

    productBlock.addEventListener('focusout', function () {
      setTimeout(function () {
        updateProductBlockImages(productBlock);
      }, 0);
    });

    window.addEventListener('resize', function () {
      updateProductBlockImages(productBlock);
    });
  }

  function init() {
    var productBlocks = document.querySelectorAll('product-block, .product-block');

    for (var i = 0; i < productBlocks.length; i++) {
      bindProductBlock(productBlocks[i]);
      updateProductBlockImages(productBlocks[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  new MutationObserver(function () {
    init();
  }).observe(document.body, {
    childList: true,
    subtree: true
  });
})();


//*** SIZE GUIDE MODAL FOCUS TRAP (PRODUCT DETAIL) ***//
// keeps focus inside the size guide modal while it is open
(function () {
  var activeModal = null;
  var trapOn = false;
  var watchedModals = {};

  function modalOpen(modal) {
    if (!modal) return false;
    if (modal.getAttribute('aria-hidden') === 'true') return false;
    return modal.hasAttribute('open');
  }

  function canFocus(element) {
    if (!element) return false;
    if (!document.contains(element)) return false;
    if (typeof element.focus !== 'function') return false;
    if (element.hasAttribute('disabled')) return false;
    if (element.closest('[aria-hidden="true"]')) return false;
    if (element.closest('[hidden]')) return false;
    if (element.closest('.size-guide-tabs__panel[hidden]')) return false;

    var style = window.getComputedStyle(element);
    if (style.display === 'none') return false;
    if (style.visibility === 'hidden') return false;

    return true;
  }

  function getFocusable(modal) {
    if (!modal) return [];

    var candidates = modal.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );

    var focusable = [];

    for (var i = 0; i < candidates.length; i++) {
      var element = candidates[i];
      if (!canFocus(element)) continue;
      focusable.push(element);
    }

    return focusable;
  }

  function enableTrap(modal) {
    activeModal = modal;

    if (trapOn) return;

    trapOn = true;
    document.addEventListener('keydown', onTrapKeydown, true);
    document.addEventListener('focusin', onTrapFocusIn, true);
  }

  function disableTrap(modal) {
    if (modal && activeModal !== modal) return;

    activeModal = null;

    if (!trapOn) return;

    trapOn = false;
    document.removeEventListener('keydown', onTrapKeydown, true);
    document.removeEventListener('focusin', onTrapFocusIn, true);
  }

  function onTrapKeydown(event) {
    if (!trapOn || !activeModal) return;
    if (!modalOpen(activeModal)) return;
    if (event.key !== 'Tab') return;

    var focusable = getFocusable(activeModal);
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    var current = document.activeElement;

    if (event.shiftKey) {
      if (current === first) {
        event.preventDefault();
        last.focus();
      }
      return;
    }

    if (current === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function onTrapFocusIn(event) {
    if (!trapOn || !activeModal) return;
    if (!modalOpen(activeModal)) return;

    var target = event.target;
    if (!target) return;
    if (activeModal.contains(target)) return;

    var focusable = getFocusable(activeModal);
    if (!focusable.length) return;

    focusable[0].focus();
  }

  function watchModal(modal) {
    var id = modal && modal.id;
    if (!id || watchedModals[id]) return;

    watchedModals[id] = true;

    var wasOpen = modalOpen(modal);

    new MutationObserver(function () {
      var isOpen = modalOpen(modal);

      if (!wasOpen && isOpen) {
        enableTrap(modal);
      }

      if (wasOpen && !isOpen) {
        disableTrap(modal);
      }

      wasOpen = isOpen;
    }).observe(modal, {
      attributes: true,
      attributeFilter: ['open', 'aria-hidden']
    });

    if (wasOpen) {
      enableTrap(modal);
    }
  }

  function init() {
    var modals = document.querySelectorAll('modal-dialog[id^="size-chart-"][role="dialog"][aria-modal="true"]');

    for (var i = 0; i < modals.length; i++) {
      watchModal(modals[i]);
    }

    new MutationObserver(function () {
      var modals = document.querySelectorAll('modal-dialog[id^="size-chart-"][role="dialog"][aria-modal="true"]');

      for (var i = 0; i < modals.length; i++) {
        watchModal(modals[i]);
      }
    }).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

//*** PAGES USING GLOBO FORMS: Powerful Contact Form Builder  ***//
// Globo Form Builder does not allow editing heading levels
// This adjusts headings after form loads to correct page hierarchy
// Applied to Wholesale & Corporate Sales page
document.addEventListener("globo.formbuilder.form.loaded", function(e) {
  const form = e.detail.form;
  if (!form) return;

  form.querySelectorAll("h3.globo-heading").forEach(function(heading){
    const h2 = document.createElement("h2");

    h2.className = heading.className;
    h2.innerHTML = heading.innerHTML;

    heading.replaceWith(h2);
  });
});

//*** FAQ PAGE WRAP FILTER + RESULTS  ***//
// needed to create one shared region for filter + results
// sections are separate in shopify, cannot be wrapped in liquid
(function () {

  function initFaqWrapper() {
    var faqHeader = document.querySelector('.section-faq-header');
    if (!faqHeader) return;

    // prevent double wrap
    if (faqHeader.closest('.faq-shared-region')) return;

    var sectionsToWrap = [faqHeader];
    var next = faqHeader.nextElementSibling;

    // collect consecutive collapsible tabs sections
    while (next && next.classList.contains('section-collapsible-tabs')) {
      sectionsToWrap.push(next);
      next = next.nextElementSibling;
    }

    // if no tabs found, do nothing
    if (sectionsToWrap.length === 1) return;

    var wrapper = document.createElement('div');
    wrapper.className = 'faq-region';
    wrapper.setAttribute('role', 'region');
    wrapper.setAttribute('aria-label', 'FAQ filter and results');

    var parent = faqHeader.parentNode;
    parent.insertBefore(wrapper, faqHeader);

    sectionsToWrap.forEach(function (el) {
      wrapper.appendChild(el);
    });
  }

  // run after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaqWrapper);
  } else {
    initFaqWrapper();
  }

})();

//*** STICKY ATC FOCUS PROTECTION ***//
(function () {
  // prevent duplicate install
  if (window.__stickyAtcFocusFix) return;
  window.__stickyAtcFocusFix = true;

  // extra breathing room above sticky
  var BUFFER = 20;

  // get sticky atc if it is actually rendered on screen
  function getVisibleStickyAtc() {
    var sticky = document.querySelector('sticky-atc.sticky-atc');
    if (!sticky) return null;

    var style = window.getComputedStyle(sticky);
    if (style.display === 'none') return null;
    if (style.visibility === 'hidden') return null;
    if (parseFloat(style.opacity) === 0) return null;

    var rect = sticky.getBoundingClientRect();
    if (!rect.width || !rect.height) return null;
    if (rect.bottom <= 0) return null;
    if (rect.top >= window.innerHeight) return null;

    return {
      element: sticky,
      rect: rect
    };
  }

  // ignore focus inside sticky itself
  function shouldIgnoreTarget(target, sticky) {
    if (!target) return true;
    if (!(target instanceof Element)) return true;
    if (!document.contains(target)) return true;
    if (sticky.contains(target)) return true;
    return false;
  }

  // move focus target above sticky zone
  function protectFocus(target) {
    var stickyData = getVisibleStickyAtc();
    if (!stickyData) return;

    var sticky = stickyData.element;
    var stickyRect = stickyData.rect;

    if (shouldIgnoreTarget(target, sticky)) return;

    var targetRect = target.getBoundingClientRect();
    if (!targetRect.width && !targetRect.height) return;

    var unsafeTop = stickyRect.top - BUFFER;

    // already above sticky zone
    if (targetRect.bottom <= unsafeTop) return;

    var needed = Math.ceil(targetRect.bottom - unsafeTop + 8);
    if (needed <= 0) return;

    window.scrollBy({
      top: needed,
      behavior: 'auto'
    }); 
  }

  document.addEventListener('focusin', function (event) {
    var target = event.target;

    requestAnimationFrame(function () {
      protectFocus(target);
    });
  }, true);
})();

//*** POLICIES MODAL: CANCELLATIONS  ***//
(function () {
  function updateCancellationHeadings() {
    var modal = document.getElementById('subscription-policy-policy-modal');
    if (!modal) return;

    var container = modal.querySelector('.go06b0');
    if (!container) return;

    var targets = ['Subscriptions', 'Pre-orders', 'Try before you buy'];

    var strongs = container.querySelectorAll('strong');

    strongs.forEach(function (el) {
      var text = el.textContent.trim();

      if (targets.includes(text)) {
        var h3 = document.createElement('h3');
        h3.className = 'modal-h3-heading';
        h3.textContent = text;

        el.replaceWith(h3);
      }
    });
  }

  // observe DOM for modal injection
  var observer = new MutationObserver(function () {
    updateCancellationHeadings();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

//*** PRODUCT BLOCK HOVER IMAGE BUTTONS ***//
// add aria-labels to previous/next buttons for keyboard + screen reader users
(function () {
  if (window.__a11yImagePageButtonsFixed) return;
  window.__a11yImagePageButtonsFixed = true;

  function fixImagePageButtons() {
    document.querySelectorAll('.image-page-button--previous').forEach(btn => {
      btn.setAttribute('aria-label', 'Previous product image');
    });

    document.querySelectorAll('.image-page-button--next').forEach(btn => {
      btn.setAttribute('aria-label', 'Next product image');
    });
  }

  // Run once after load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixImagePageButtons);
  } else {
    fixImagePageButtons();
  }
})();

//*** PRODUCT BLOCK IMAGE NAVIGATION (PREV/NEXT ARROWS) ***//
// Make keyboard activation (Enter/Space) trigger the existing theme logic
(function () {
  if (window.__a11yProductImageNavInstalled) return;
  window.__a11yProductImageNavInstalled = true;

  // wait until  custom elem is fully defined and initialized
  function initKeyboardImageNav() {
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;

      const button = e.target.closest('.image-page-button');
      if (!button) return;

      const productBlock = button.closest('product-block');
      if (!productBlock || typeof productBlock.incrementActiveImage !== 'function') return;

      e.preventDefault();

      const isNext = button.classList.contains('image-page-button--next');

      if (isNext) {
        productBlock.incrementActiveImage(1);
      } else {
        productBlock.incrementActiveImage(-1);
      }
    });
  }

  // run after custom elements are upgraded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKeyboardImageNav);
  } else {
    // small delay to ensure custom element methods are attached
    setTimeout(initKeyboardImageNav, 100);
  }
})();

//*** CUSTOM SLICK SLIDER: slide group labels (ABOUT page) ***//
// add role="group" and aria-label="Slide X of Y" to real slides only
(function () {
  if (window.__a11yCustomSlickSliderInstalled) return;
  window.__a11yCustomSlickSliderInstalled = true;

  function updateCustomSlickSlider(slider) {
    if (!slider) return;

    var realSlides = slider.querySelectorAll('.slick-slide:not(.slick-cloned)');
    var clonedSlides = slider.querySelectorAll('.slick-slide.slick-cloned');
    var total = realSlides.length;

    if (!total) return;

    for (var i = 0; i < realSlides.length; i++) {
      var slide = realSlides[i];
      var label = 'Slide ' + (i + 1) + ' of ' + total;

      if (slide.getAttribute('role') !== 'group') {
        slide.setAttribute('role', 'group');
      }

      if (slide.getAttribute('aria-label') !== label) {
        slide.setAttribute('aria-label', label);
      }
    }

    for (var j = 0; j < clonedSlides.length; j++) {
      var cloned = clonedSlides[j];

      if (cloned.getAttribute('aria-hidden') !== 'true') {
        cloned.setAttribute('aria-hidden', 'true');
      }
    }
  }

  function initCustomSlickSliderA11y() {
    var slider = document.querySelector('.customs-slider-wrapper');
    if (!slider) return;

    updateCustomSlickSlider(slider);

    if (slider.__a11yCustomSlickObserved) return;
    slider.__a11yCustomSlickObserved = true;

    var scheduled = false;

    function scheduleUpdate() {
      if (scheduled) return;
      scheduled = true;

      requestAnimationFrame(function () {
        scheduled = false;
        updateCustomSlickSlider(slider);
      });
    }

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];

        if (m.type === 'childList') {
          scheduleUpdate();
          return;
        }

        if (
          m.type === 'attributes' &&
          m.attributeName === 'class'
        ) {
          scheduleUpdate();
          return;
        }
      }
    }).observe(slider, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(initCustomSlickSliderA11y, 150);
    });
  } else {
    setTimeout(initCustomSlickSliderA11y, 150);
  }
})();


/* CAROUSELS / COLLECTION PAGES */
//*** KING LINKED OPTIONS SWATCHES ***//
// Move King controls outside product link
// group the color button controls + add Space key support
(function () {
  if (window.__a11yKingSwatchesInstalled) return;
  window.__a11yKingSwatchesInstalled = true;

  function moveKingOutsideLink(productBlock) {
    if (!productBlock) return null;

    var kingContainer = productBlock.querySelector(
      'king-linked-options-collection'
    );

    if (!kingContainer) return null;

    var parentLink = kingContainer.closest(
      '.product-block__detail a.product-link'
    );

    if (!parentLink) return kingContainer;

    var innerer = parentLink.closest('.innerer');
    if (!innerer) return kingContainer;

    innerer.insertBefore(kingContainer, parentLink.nextSibling);
    kingContainer.dataset.a11yMovedOutsideLink = 'true';

    return kingContainer;
  }

  function enhanceKingContainer(kingContainer) {
    if (!kingContainer) return;

    kingContainer.setAttribute('role', 'group');
    kingContainer.setAttribute('aria-label', 'Color options');

    kingContainer
      .querySelectorAll('.lv-option-collection-item[role="button"]')
      .forEach(function (swatch) {

        if (swatch.dataset.a11ySpaceKeyEnabled === 'true') return;

        swatch.dataset.a11ySpaceKeyEnabled = 'true';

        swatch.addEventListener('keydown', function (event) {
          if (event.key !== ' ' && event.code !== 'Space') return;

          event.preventDefault();
          swatch.click();
        });
      });
  }

  function enhanceKingSwatches() {
    document
      .querySelectorAll('.product-grid .product-block')
      .forEach(function (productBlock) {

        var kingContainer = moveKingOutsideLink(productBlock);
        if (!kingContainer) return;

        enhanceKingContainer(kingContainer);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      enhanceKingSwatches
    );
  } else {
    enhanceKingSwatches();
  }

  setTimeout(enhanceKingSwatches, 800);
  setTimeout(enhanceKingSwatches, 1800);

  new MutationObserver(function () {
    enhanceKingSwatches();
  }).observe(document.body, {
    childList: true,
    subtree: true
  });
})();

/* CAROUSELS / COLLECTION PAGES */
/* THEME SWATCHES - keyboard support for deep link swatches */
(function () {
  if (window.__a11yThemeSwatchKeyboardInstalled) return;
  window.__a11yThemeSwatchKeyboardInstalled = true;

  function activateSwatchLink(link) {
    if (!link || !link.href) return;
    window.location.href = link.href;
  }

  function enableThemeSwatchKeyboard() {
    document.querySelectorAll('.product-grid .product-block-options__item[href]').forEach(function (swatch) {
      if (swatch.dataset.a11yThemeSwatchBound === 'true') return;
      swatch.dataset.a11yThemeSwatchBound = 'true';

      swatch.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;

        e.preventDefault();
        e.stopPropagation();
        activateSwatchLink(swatch);
      });

      swatch.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        activateSwatchLink(swatch);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enableThemeSwatchKeyboard);
  } else {
    enableThemeSwatchKeyboard();
  }

  setTimeout(enableThemeSwatchKeyboard, 800);
  setTimeout(enableThemeSwatchKeyboard, 1800);

  new MutationObserver(enableThemeSwatchKeyboard).observe(document.body, {
    childList: true,
    subtree: true
  });
})();

/* CAROUSELS / COLLECTION PAGES */
//*** THEME SWATCHES - MORE BUTTON ***//
(function () {
  if (window.__a11yThemeSwatchMoreInstalled) return;
  window.__a11yThemeSwatchMoreInstalled = true;

  function expandSwatchGroup(control) {
    if (!control) return;

    var group = control.closest('.product-block-options');
    if (!group) return;

    group.classList.add('a11y-swatches-expanded');
    control.setAttribute('aria-expanded', 'true');
    control.setAttribute('hidden', 'hidden');

    var firstNewLink = group.querySelector('.product-block-options__item--truncated[href]');
    if (firstNewLink) {
      firstNewLink.focus();
    }
  }

  function bindMoreButtons() {
    document.querySelectorAll('.product-block-options__more-label[role="button"]').forEach(function (control) {
      if (control.dataset.a11yMoreBound === 'true') return;
      control.dataset.a11yMoreBound = 'true';

      control.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        expandSwatchGroup(control);
      });

      control.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;

        e.preventDefault();
        e.stopPropagation();
        expandSwatchGroup(control);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindMoreButtons);
  } else {
    bindMoreButtons();
  }

  setTimeout(bindMoreButtons, 800);
  setTimeout(bindMoreButtons, 1800);

  new MutationObserver(bindMoreButtons).observe(document.body, {
    childList: true,
    subtree: true
  });
})();

/* CAROUSELS / COLLECTION PAGES */
//*** FEATURED COLLECTION CAROUSEL (Just Dropped) - HIDE NON-VISIBLE SLIDES ***//
(function () {
  if (window.__a11yCarouselSliderFixInstalled) return;
  window.__a11yCarouselSliderFixInstalled = true;

  var PREV_TAB = 'data-a11y-prev-tabindex';
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function disableFocusables(slide) {
    var focusables = slide.querySelectorAll(FOCUSABLE);

    for (var i = 0; i < focusables.length; i++) {
      var el = focusables[i];

      if (!el.hasAttribute(PREV_TAB)) {
        var prev = el.getAttribute('tabindex');
        el.setAttribute(PREV_TAB, prev === null ? '' : prev);
      }

      el.setAttribute('tabindex', '-1');
    }
  }

  function restoreFocusables(slide) {
    var changed = slide.querySelectorAll('[' + PREV_TAB + ']');

    for (var i = 0; i < changed.length; i++) {
      var el = changed[i];
      var prev = el.getAttribute(PREV_TAB);

      el.removeAttribute(PREV_TAB);

      if (prev === '') {
        el.removeAttribute('tabindex');
      } else {
        el.setAttribute('tabindex', prev);
      }
    }
  }

  function isMostlyVisible(slide, viewport) {
    var rect = slide.getBoundingClientRect();
    var view = viewport.getBoundingClientRect();

    if (!rect.width || !rect.height) return false;

    var tolerance = 4;

    return (
      rect.left >= view.left - tolerance &&
      rect.right <= view.right + tolerance
    );
  }

  function fixCarousel(carousel) {
    if (!carousel || carousel.__a11yCarouselSliderFixed) return;
    carousel.__a11yCarouselSliderFixed = true;

    var slider = carousel.querySelector('.slider');
    if (!slider) return;

    var scheduled = false;

    function updateSlides() {
      scheduled = false;

      var slides = carousel.querySelectorAll('.slider__item');

      for (var i = 0; i < slides.length; i++) {
        var slide = slides[i];
        var visible = isMostlyVisible(slide, slider);

        if (visible) {
          slide.removeAttribute('aria-hidden');
          slide.removeAttribute('tabindex');
          restoreFocusables(slide);
        } else {
          slide.setAttribute('aria-hidden', 'true');
          slide.removeAttribute('tabindex');
          disableFocusables(slide);
        }
      }
    }

    function scheduleUpdate() {
      if (scheduled) return;
      scheduled = true;

      requestAnimationFrame(updateSlides);
    }

    scheduleUpdate();
    setTimeout(scheduleUpdate, 300);
    setTimeout(scheduleUpdate, 1000);

    slider.addEventListener('scroll', scheduleUpdate, { passive: true });

    var scrollLeftBeforeTab = null;

    carousel.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab') return;
      scrollLeftBeforeTab = slider.scrollLeft;
    }, true);

    carousel.addEventListener('focusin', function (event) {
      var productImageButton = event.target.closest('.image-page-button');
      if (!productImageButton) return;

      var slide = productImageButton.closest('.slider__item');
      if (!slide) return;

      if (slide.getAttribute('aria-hidden') === 'true') return;
      if (scrollLeftBeforeTab === null) return;

      requestAnimationFrame(function () {
        slider.scrollLeft = scrollLeftBeforeTab;
        scrollLeftBeforeTab = null;
        scheduleUpdate();
      });
    }, true);

    carousel.addEventListener('on:carousel-slider:select', function () {
      setTimeout(scheduleUpdate, 100);
    });

    new MutationObserver(scheduleUpdate).observe(carousel, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  }

  function init() {
    document.querySelectorAll('carousel-slider').forEach(fixCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', init);
})();

//*** TESTIMONIAL CAROUSEL BUTTON POSITION FIX ***//
(function () {
  if (window.__testimonialFinalFix) return;
  window.__testimonialFinalFix = true;

  function fixTestimonials() { 
    document.querySelectorAll('.a11y-testimonial-prev-ctrl, .a11y-testimonial-next-ctrl').forEach(function (ctrl) {
      if (ctrl) ctrl.style.position = 'absolute';
    });

    // stop slide from being focusable
    document.querySelectorAll('.testimonial-list .slideshow__slide').forEach(function (slide) {
      slide.setAttribute('tabindex', '-1');
    });
  }

  fixTestimonials();
  setTimeout(fixTestimonials, 800);  // after theme JS runs
  window.addEventListener('load', fixTestimonials);
  document.addEventListener('shopify:section:load', fixTestimonials);
})();

//*** AI TABBED COLLECTION CAROUSELS - HIDE NON-VISIBLE SLIDES ***// 
(function () {
  function updateAiCollectionSlides(slider) {
    var sliderRect = slider.getBoundingClientRect();
    var slides = slider.querySelectorAll(
      'a[class*="ai-tabbed-collections__collection-card-"]'
    );

    // allow a few pixels of leeway when checking if a slide is visible
    var tolerance = 4;

    slides.forEach(function (slide) {
      var slideRect = slide.getBoundingClientRect();

      var isVisible =
        slideRect.width > 0 &&
        slideRect.left >= sliderRect.left - tolerance &&
        slideRect.right <= sliderRect.right + tolerance;

      if (isVisible) {
        slide.removeAttribute('aria-hidden');
        slide.removeAttribute('tabindex');
      } else {
        slide.setAttribute('aria-hidden', 'true');
        slide.setAttribute('tabindex', '-1');
      }
    });
  }

  function initAiCollectionSlides() {
    var sliders = document.querySelectorAll(
      '[class*="ai-tabbed-collections__slider-"][data-slider]'
    );

    sliders.forEach(function (slider) {
      if (!slider.dataset.a11ySlidesBound) {
        slider.dataset.a11ySlidesBound = 'true';

        slider.addEventListener('scroll', function () {
          updateAiCollectionSlides(slider);
        });
      }

      updateAiCollectionSlides(slider);
    });
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest('[role="tab"]')) return;

    setTimeout(initAiCollectionSlides, 100);
  });

  window.addEventListener('resize', initAiCollectionSlides);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAiCollectionSlides);
  } else {
    initAiCollectionSlides();
  }
})();

//*** FEATURED COLLECTION CAROUSEL (Just Dropped) NEXT BUTTON TAB ORDER FIX ***//
// Keeps the working theme Next button in place,
// but provides a second Next button after the slides for correct keyboard order.
(function () {
  if (window.__a11yFeaturedCollectionNextBridgeInstalled) return;
  window.__a11yFeaturedCollectionNextBridgeInstalled = true;

  document.addEventListener('click', function (event) {
    var visibleNext = event.target.closest('carousel-slider .a11y-visible-next');
    if (!visibleNext) return;

    var carousel = visibleNext.closest('carousel-slider');
    if (!carousel) return;

    var originalNext = carousel.querySelector('.a11y-original-next');
    if (!originalNext) return;

    event.preventDefault();
    originalNext.click();
  }, true);
})();



// ** SHOGUN TABS/ACCORDIONS ** //
// make TABS keyboard focusable
(function () {
  function getTabs(tablist) {
    return Array.from(tablist.querySelectorAll('[role="tab"]'));
  }

  function setRovingTabindex(tabs, activeTab) {
    tabs.forEach(function (t) {
      t.setAttribute('tabindex', t === activeTab ? '0' : '-1');
    });
  }

  function activateTab(tab) {
    tab.click();
    var tablist = tab.closest('[role="tablist"]');
    if (!tablist) return;
    var tabs = getTabs(tablist);
    setRovingTabindex(tabs, tab);
  }

  function initTablist(tablist) {
    var tabs = getTabs(tablist);
    if (!tabs.length) return;

    var active = tablist.querySelector('[role="tab"][aria-selected="true"]') || tabs[0];

    tabs.forEach(function (t) {
      if (!t.hasAttribute('tabindex')) t.setAttribute('tabindex', '-1');
    });
    setRovingTabindex(tabs, active);

    tablist.addEventListener('click', function (e) {
      var tab = e.target.closest('[role="tab"]');
      if (!tab || !tablist.contains(tab)) return;
      activateTab(tab);
    });

    tablist.addEventListener('keydown', function (e) {
      var tab = e.target.closest('[role="tab"]');
      if (!tab || !tablist.contains(tab)) return;

      var tabs = getTabs(tablist);
      var i = tabs.indexOf(tab);
      if (i < 0) return;

      var next;

      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        activateTab(tab);
        tab.focus();
        return;
      }

      if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
      else if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
      else if (e.key === 'Home') next = tabs[0];
      else if (e.key === 'End') next = tabs[tabs.length - 1];
      else return;

      e.preventDefault();
      setRovingTabindex(tabs, next);
      next.focus();
    });
  }

  function initAll() {
    document.querySelectorAll('.shogun-tabs[role="tablist"], [role="tablist"]').forEach(function (tablist) {
      if (tablist.dataset.a11yTabsInit === 'true') return;
      tablist.dataset.a11yTabsInit = 'true';
      initTablist(tablist);
    });
  }

  initAll();
  document.addEventListener('shogun:loaded', initAll);
})();

// make ACCORDIONS keyboard focusable + expose expanded state
(function () {
  if (window.__a11yShogunAccordionsInstalled) return;
  window.__a11yShogunAccordionsInstalled = true;

  function getAccordionBodyId(body, index) {
    if (body.id) return body.id;

    var id = 'a11y-shogun-accordion-panel-' + index;
    body.id = id;
    return id;
  }

  function isExpanded(body) {
    if (!body) return false;

    if (body.classList.contains('shogun-accordion-active')) return true;

    var style = window.getComputedStyle(body);
    return style.display !== 'none';
  }

  function syncAccordionState(header, body, index) {
    if (!header || !body) return;

    var bodyId = getAccordionBodyId(body, index);
    var expanded = isExpanded(body);

    if (!header.hasAttribute('tabindex')) header.setAttribute('tabindex', '0');
    if (!header.hasAttribute('role')) header.setAttribute('role', 'button');

    header.setAttribute('aria-controls', bodyId);
    header.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function initAccordions(root) {
    var accordions = (root || document).querySelectorAll('.shogun-accordion');

    accordions.forEach(function (accordion, index) {
      var header = accordion.querySelector('.shogun-accordion-header');
      var body = accordion.querySelector('.shogun-accordion-body');

      if (!header || !body) return;

      syncAccordionState(header, body, index);

      if (header.dataset.a11yAccInit !== 'true') {
        header.dataset.a11yAccInit = 'true';

        header.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter' && e.key !== ' ') return;
          e.preventDefault();
          header.click();
        });

        header.addEventListener('click', function () {
          window.requestAnimationFrame(function () {
            syncAccordionState(header, body, index);
          });
        });
      }
    });
  }

  function observeAccordions() {
    var observer = new MutationObserver(function () {
      initAccordions(document);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  }

  initAccordions(document);
  observeAccordions();

  document.addEventListener('shogun:loaded', function () {
    initAccordions(document);
  });
})();

// ** SHOGUN SIZE GUIDE PAGE ** //
(function () {
  /*
    Removing Shogun 3rd-party app auto-generated alt text on the large “Size Guide” header image.

    The Shogun editor does not provide a reliable way to remove or control the rendered alt for this instance.
    The image is a visual heading only, we are adding a proper <h1> on the page.
    To prevent redundant and noisy screen reader output, we force alt="" after Shogun renders.

    We intentionally avoid targeting a specific Shogun image ID, since that asset can change.
    Instead we target the rendered structure: .shg-image-overflow > img
  */

  var SELECTOR = '.shg-image-overflow > img';

  function clearAlt() {
    var img = document.querySelector(SELECTOR);
    if (!img) return;

    // Always force decorative alt
    if (img.getAttribute('alt') !== '') {
      img.setAttribute('alt', '');
    }
  }

  // Run after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', clearAlt);
  } else {
    clearAlt();
  }

  // Run again after full load in case Shogun hydrates late
  window.addEventListener('load', clearAlt);

  // Re-run if Shogun rehydrates and restores alt, or injects the image later
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];

      // If an img node was added anywhere, try again
      if (m.type === 'childList' && m.addedNodes && m.addedNodes.length) {
        clearAlt();
        return;
      }

      // If the target image's alt changes, force it back to empty
      if (m.type === 'attributes' && m.attributeName === 'alt') {
        if (m.target && m.target.matches && m.target.matches(SELECTOR)) {
          clearAlt();
          return;
        }
      }
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['alt']
  });
})();

//*** SHOGUN SIZE GUIDE ACCORDION STRUCTURE FIX ***//
// post render fix //
(function () {
  if (window.__a11yShogunSizeGuideAccordionFixInstalled) return;
  window.__a11yShogunSizeGuideAccordionFixInstalled = true;

  function getSizeGuideRoot() {
    return document.querySelector('[data-shogun-page-id="68375490a575ccb40a198a9d"]');
  }

  function convertTitleToSpan(header) {
    var title = header.querySelector('.shogun-accordion-title');
    var span;
    var i;
    var attr;

    if (!title) return;
    if (title.tagName === 'SPAN') return;

    span = document.createElement('span');

    for (i = 0; i < title.attributes.length; i++) {
      attr = title.attributes[i];
      span.setAttribute(attr.name, attr.value);
    }

    span.innerHTML = title.innerHTML;
    title.parentNode.replaceChild(span, title);
  }

  function wrapHeaderInH2(header) {
    var h2;
    var parent;

    if (!header) return;
    if (header.parentNode && header.parentNode.tagName === 'H2') return;

    parent = header.parentNode;
    if (!parent) return;

    h2 = document.createElement('h2');
    h2.className = 'a11y-shogun-accordion-heading';
    h2.style.margin = '0';

    parent.insertBefore(h2, header);
    h2.appendChild(header);
  }

  function fixAccordionHeaders() {
    var root = getSizeGuideRoot();
    var headers;

    if (!root) return;

    headers = root.querySelectorAll('.shogun-accordion-heading > .shogun-accordion-header');

    headers.forEach(function (header) {
      convertTitleToSpan(header);
      wrapHeaderInH2(header);
    });
  }

  function initFix() {
    fixAccordionHeaders();

    new MutationObserver(function () {
      fixAccordionHeaders();
    }).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFix);
  } else {
    initFix();
  }
})();

//*** FAQ JUMP LINK FOCUS FIX ***//
(function () {
  if (window.__a11yFaqJumpFocusInstalled) return;
  window.__a11yFaqJumpFocusInstalled = true;

  function moveFocusFromHash(hash) {
    if (!hash || hash.charAt(0) !== '#') return;

    var target = document.querySelector(hash);
    if (!target) return;

    // ensure focusable
    if (!target.hasAttribute('tabindex')) {
      target.setAttribute('tabindex', '-1');
    }

    target.focus();
  }

  // handle click (mouse + keyboard activation)
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.faq-index-item__link');
    if (!link) return;

    var hash = link.getAttribute('href');
    if (!hash || hash.charAt(0) !== '#') return;

    // allow scroll first, then move focus
    setTimeout(function () {
      moveFocusFromHash(hash);
    }, 0);
  });

  // handle direct hash navigation (page load / refresh)
  window.addEventListener('load', function () {
    if (window.location.hash) {
      moveFocusFromHash(window.location.hash);
    }
  });
})();

//*** SHOGUN TABLE COLUMN HEADERS ***//
(function () {
  if (window.__a11yShogunTableHeadersInstalled) return;
  window.__a11yShogunTableHeadersInstalled = true;

  function upgradeShogunTableHeaders() {
    var tables = document.querySelectorAll(
      '.shogun-table-wrapper table.shogun-table'
    );

    tables.forEach(function (table) {
      var headerCells = table.querySelectorAll(
        'thead.shogun-table-column-container > tr > td.shogun-table-column'
      );

      if (!headerCells.length) return;

      headerCells.forEach(function (cell) {
        var th = document.createElement('th');

        Array.from(cell.attributes).forEach(function (attr) {
          th.setAttribute(attr.name, attr.value);
        });

        th.setAttribute('scope', 'col');
        th.innerHTML = cell.innerHTML;

        cell.parentNode.replaceChild(th, cell);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', upgradeShogunTableHeaders);
  } else {
    upgradeShogunTableHeaders();
  }
})();

//*** SHOGUN TABLE HEADER STYLES ***//
// because of shogun overrides to CSS in codebase
(function () {
  if (window.__a11yShogunTableHeaderStylesInstalled) return;
  window.__a11yShogunTableHeaderStylesInstalled = true;

  var style = document.createElement('style');
  style.setAttribute('data-a11y', 'shogun-table-th');

  style.textContent = `
    th.shogun-table-column {
      background-color: #efefef;
      border: 1px solid #D5D6D7;
    }
  `;

  document.head.appendChild(style);
})();


//*** PROMOTIONAL ANNOUNCEMENT REGION ***//
(function () {

  if (window.__a11yPromotionalAnnouncementRegionInstalled) return;
  window.__a11yPromotionalAnnouncementRegionInstalled = true;

  function applyRegion(el) {
    if (!el) return;

    el.setAttribute('role', 'region');
    el.setAttribute('aria-label', 'Promotional announcement');
  }

  function run() {
    var vendorBar = document.querySelector('.aph_bar_bar');
    applyRegion(vendorBar);
  }

  run();

  var observer = new MutationObserver(function () {
    run();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();

//*** REGISTER FORM ERROR FOCUS ***//
(function () {
  if (window.__a11yRegisterErrorFocusInstalled) return;
  window.__a11yRegisterErrorFocusInstalled = true;

  function focusFirstError() {
    var firstErrorField = document.querySelector('#create_customer [aria-invalid="true"]');
    if (!firstErrorField) return;

    setTimeout(function () {
      firstErrorField.focus({ preventScroll: true });
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', focusFirstError);
  } else {
    focusFirstError();
  }
})();

//*** REGISTER FORM CLIENT-SIDE REQUIRED FIELD ERRORS ***//
(function () {
  if (window.__a11yRegisterClientRequiredErrorsInstalled) return;
  window.__a11yRegisterClientRequiredErrorsInstalled = true;

  function addDescribedBy(input, id) {
    var current = input.getAttribute('aria-describedby') || '';
    var ids = current.split(/\s+/).filter(Boolean);

    if (ids.indexOf(id) === -1) {
      ids.push(id);
    }

    input.setAttribute('aria-describedby', ids.join(' '));
  }

  function removeDescribedBy(input, id) {
    var current = input.getAttribute('aria-describedby') || '';
    var ids = current.split(/\s+/).filter(function (item) {
      return item && item !== id;
    });

    if (ids.length) {
      input.setAttribute('aria-describedby', ids.join(' '));
    } else {
      input.removeAttribute('aria-describedby');
    }
  }

  function initRegisterClientErrors() {
    var form = document.querySelector('#create_customer');
    if (!form) return;

    var summary = form.querySelector('#create-customer-client-errors');
    var list = summary ? summary.querySelector('ul') : null;

    var fields = [
      {
        id: 'first_name',
        errorId: 'first-name-error',
        message: "First name can't be blank"
      },
      {
        id: 'last_name',
        errorId: 'last-name-error',
        message: "Last name can't be blank"
      },
      {
        id: 'email',
        errorId: 'email-error',
        message: "Email can't be blank"
      },
      {
        id: 'password',
        errorId: 'password-error',
        message: "Password can't be blank"
      }
    ];

    form.addEventListener('submit', function (event) {
      var errors = [];
      var firstInvalidField = null;

      fields.forEach(function (field) {
        var input = document.getElementById(field.id);
        var error = document.getElementById(field.errorId);

        if (!input || !error) return;

        if (!input.value.trim()) {
          input.setAttribute('aria-invalid', 'true');
          addDescribedBy(input, field.errorId);
          error.textContent = field.message;

          errors.push(field.message);

          if (!firstInvalidField) {
            firstInvalidField = input;
          }
        } else {
          input.removeAttribute('aria-invalid');
          removeDescribedBy(input, field.errorId);
          error.textContent = '';
        }
      });

      if (!errors.length) return;

      event.preventDefault();

      if (summary && list) {
        list.innerHTML = '';

        errors.forEach(function (message) {
          var item = document.createElement('li');
          item.textContent = message;
          list.appendChild(item);
        });

        summary.hidden = false;
      }

      firstInvalidField.focus({ preventScroll: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRegisterClientErrors);
  } else {
    initRegisterClientErrors();
  }
})();

/*** MATTERPORT IFRAME TITLE FOR SHOWROOM PAGE (ACCESSIBLE NAME) ***/
(function () {
  function labelMatterportIframe() {
    const iframe = document.querySelector('iframe[src*="my.matterport.com"]');
    if (!iframe) return;

    iframe.setAttribute('title', 'Interactive 3D showroom tour');
  }

  labelMatterportIframe();
  document.addEventListener('shopify:section:load', labelMatterportIframe);
})();
 
//*** PRODUCT PAGE THUMBNAIL LINKS 
// allow SPACE key to activate PDP thumbmail links marked as buttons 
(function () {
  function enablePdpThumbnailButtonSpaceKey() {
    document.querySelectorAll('.media-gallery .thumbnails a.thumbnail[role="button"]').forEach(function (thumbnail) {
      if (thumbnail.dataset.a11ySpaceKeyEnabled === 'true') return;

      thumbnail.dataset.a11ySpaceKeyEnabled = 'true';

      thumbnail.addEventListener('keydown', function (event) {
        if (event.key !== ' ') return;

        event.preventDefault();
        thumbnail.click();
      });
    });
  }

  enablePdpThumbnailButtonSpaceKey();

  document.addEventListener('shopify:section:load', enablePdpThumbnailButtonSpaceKey);

  // Quick Buy drawer
  document.addEventListener('on:quickbuy:after-open', function () {
    enablePdpThumbnailButtonSpaceKey();
  });
})();


//*** MAKE COLLECTION 'READ MORE' TOGGLE KEYBOARD ACCESSIBLE ***//
(function () {
  function fixCollectionReadMoreButtons() {
    document.querySelectorAll('.template-collection .rte .read-more-button').forEach(function (button) {
      if (button.dataset.a11yReadMoreFixed === 'true') return;

      button.setAttribute('role', 'button');
      button.setAttribute('tabindex', '0');

      button.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;

        event.preventDefault();
        button.click();
      });

      button.dataset.a11yReadMoreFixed = 'true';
    });
  }

  fixCollectionReadMoreButtons();
  document.addEventListener('shopify:section:load', fixCollectionReadMoreButtons);
})();
 
//*** PDP KING LINKED OPTIONS COLOR SWATCH SELECTED STATE ***//
(function () {
  if (window.__a11yPdpKingColorSelectedInstalled) return;
  window.__a11yPdpKingColorSelectedInstalled = true;

  function updatePdpKingColorSelectedState() {
    if (
      !document.body.classList.contains('template-product') &&
      !window.location.pathname.includes('/products/')
    ) return;

    var root = document.querySelector(
      'king-linked-options-product[data-render-context="product-page"]'
    );

    if (!root) return;

    root.querySelectorAll('.lv-option-item-link').forEach(function (link) {
      var colorName = link.getAttribute('data-value') || 'Color';
      var isSelected = link.classList.contains('lv-option-item__active');

      if (isSelected) {
        link.setAttribute('aria-current', 'true');
        link.setAttribute('aria-label', 'View ' + colorName + ' color, selected');
      } else {
        link.removeAttribute('aria-current');
        link.setAttribute('aria-label', 'View ' + colorName + ' color');
      }
    });
  }

  updatePdpKingColorSelectedState();
  document.addEventListener('shopify:section:load', updatePdpKingColorSelectedState);

  new MutationObserver(updatePdpKingColorSelectedState).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });
})();

//*** PDP CAROUSEL NEXT BUTTON DOM ORDER BRIDGE ***//
// Next button moved after slides for focus order.
// Theme JS is wired to the original Next button before the slides.
// Keep original hidden and trigger it from the visible Next button.
(function () {
  if (window.__a11yPdpCarouselNextBridgeInstalled) return;
  window.__a11yPdpCarouselNextBridgeInstalled = true;

  document.addEventListener('click', function (event) {
    var visibleNext = event.target.closest('.media-gallery .main-image .a11y-pdp-visible-next');
    if (!visibleNext) return;

    var carousel = visibleNext.closest('carousel-slider');
    if (!carousel) return;

    var originalNext = carousel.querySelector('.a11y-pdp-original-next');
    if (!originalNext) return;

    event.preventDefault();
    originalNext.click();
  }, true);
})();

//*** FIT SLIDER CARD VISIBILITY AND KEYBOARD FOCUS ***//
(function () {
  // initialize all fit sliders on the page
  function initFitSliderA11y() {
    var sliders = document.querySelectorAll('.fit-slider-shell');

    sliders.forEach(function (slider) {
      var viewport = slider.querySelector('.fit-slider-viewport');
      var track = slider.querySelector('[data-slider-track]');
      var cards = slider.querySelectorAll('.fit-slider-card');

      if (!viewport || !track || !cards.length) return;

      var prevButton = slider.querySelector('[data-slider-prev]');
      var nextButton = slider.querySelector('[data-slider-next]');

      // get all focusable elements inside a card
      function getFocusableItems(card) {
        return card.querySelectorAll('a, button, input, select, textarea, [tabindex]');
      }

      // restore previously stored tabindex values for card content that becomes visible again
      function makeCardAccessible(card) {
        var focusableItems = getFocusableItems(card);
        card.removeAttribute('aria-hidden');

        focusableItems.forEach(function (item) {
          // use stored tabindex values when offscreen/non-visible card content becomes visible again
          if (item.getAttribute('data-fit-slider-tabindex') !== null) {
            item.setAttribute('tabindex', item.getAttribute('data-fit-slider-tabindex'));
            item.removeAttribute('data-fit-slider-tabindex');

          // else allow natural keyboard focus
          } else {
            item.removeAttribute('tabindex');
          }
        });
      }

      // hide offscreen cards from screen readers and keyboard users
      function hideCardFromAccessibility(card) {
        var focusableItems = getFocusableItems(card);

        card.setAttribute('aria-hidden', 'true');

        focusableItems.forEach(function (item) {
          // store existing tabindex values for later use when cards become visible again
          if (
            item.getAttribute('tabindex') !== null &&
            item.getAttribute('data-fit-slider-tabindex') === null
          ) {
            item.setAttribute('data-fit-slider-tabindex', item.getAttribute('tabindex'));
          }

          item.setAttribute('tabindex', '-1');
        });
      }

      // is most of the card visible in the scroll area within viewport
      function isCardMostlyVisible(card) {
        var cardLeft = card.offsetLeft;
        var cardRight = cardLeft + card.offsetWidth;

        var visibleLeft = track.scrollLeft;
        var visibleRight = visibleLeft + track.clientWidth;

        var visibleWidth =
          Math.min(cardRight, visibleRight) -
          Math.max(cardLeft, visibleLeft);

        return visibleWidth >= card.offsetWidth * 0.85;
      }

      // disable arrows when no additional cards are available
      function updateArrowButtons() {
        if (!prevButton || !nextButton) return;

        var firstCard = cards[0];

        var maxScrollLeft = track.scrollWidth - track.clientWidth;
        var atStart = firstCard && isCardMostlyVisible(firstCard);
        var atEnd = track.scrollLeft >= maxScrollLeft - 5;

        prevButton.disabled = atStart;
        nextButton.disabled = atEnd;

        prevButton.classList.toggle('is-disabled', atStart);
        nextButton.classList.toggle('is-disabled', atEnd);
      }

      // update accessibility state for all cards
      function updateCardVisibility() {
        cards.forEach(function (card) {

          // visible cards remain accessible
          if (isCardMostlyVisible(card)) {
            makeCardAccessible(card);

          // offscreen cards are hidden from accessibility APIs
          } else {
            hideCardFromAccessibility(card);
          }
        });

        updateArrowButtons();
      }

      // run once on load
      updateCardVisibility();

      // update while scrolling the carousel
      track.addEventListener('scroll', updateCardVisibility, {
        passive: true
      });

      // update on resize because visible cards change by breakpoint
      window.addEventListener('resize', updateCardVisibility);
    });
  }

  // initialize after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFitSliderA11y);
  } else {
    initFitSliderA11y();
  }
})(); 

// *** NAVIGATION **//
// top level nav 
// desktop navigation accessibility remediation.
// Uses an explicit submenu toggle, preserves hover behavior,
// prevents menus opening on focus, and keeps submenu links untabbable until opened. 
const clearNavCloseTimer = (menuItem) => {
  const id = Number(menuItem?.dataset?.navCloseTimeoutId);
  if (!Number.isNaN(id)) {
    clearTimeout(id);
    delete menuItem.dataset.navCloseTimeoutId;
  }
};

//*** NAVIGATION PROMO IMAGE ALT CLEANUP ***//
// If a navigation promo image link has an aria-label (added in EDIT THEME), empty the alt text if it exists.
(function () {
  if (window.__a11yNavPromoImageAltCleanupInstalled) return;
  window.__a11yNavPromoImageAltCleanupInstalled = true;

  function updateNavPromoImageAlts() {
    document
      .querySelectorAll('.navigation__column--promotion .menu-promotion__link[aria-label]')
      .forEach(function (link) {
        link.querySelectorAll('.menu-promotion__image img').forEach(function (img) {
          img.setAttribute('alt', '');
        });
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateNavPromoImageAlts);
  } else {
    updateNavPromoImageAlts();
  }

  document.addEventListener('shopify:section:load', updateNavPromoImageAlts);

  new MutationObserver(updateNavPromoImageAlts).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();

//*** MOBILE MENU NAVIGATION ***//
// // === #1 - MOBILE DRAWER BUTTON KEYBOARD ACTIVATION
(function () {
  if (window.__mobileNavKeyboardFixV2) return;
  window.__mobileNavKeyboardFixV2 = true;

  theme.addDelegateEventListener(document, 'keydown', '.mobile-navigation-drawer [role="button"], .mobile-navigation-drawer button', function (evt, toggle) {
    const isSpace = evt.key === ' ' || evt.key === 'Spacebar' || evt.code === 'Space';
    const isEnter = evt.key === 'Enter';

    if (!isEnter && !isSpace) return;

    evt.preventDefault();
    toggle.click();
  });
})();

// // === #2 - HIDE INACTIVE TIER 1 ITEMS WHEN TIER 2 OPENS
(function () {
  if (window.__hideInactiveTier1) return;
  window.__hideInactiveTier1 = true;

  // theme.addDelegateEventListener(document, 'click', '.mobile-navigation-drawer [data-a11y-submenu="true"], .mobile-navigation-drawer .navigation__children-toggle', function (evt, toggle) {
  theme.addDelegateEventListener(document, 'click', '.mobile-navigation-drawer .navigation__tier-1 > .navigation__item > .navigation__children-toggle', function (evt, toggle) {
    const clickedItem = toggle.closest('.navigation__item');
    if (!clickedItem) return;

    const drawer = document.querySelector('.mobile-navigation-drawer');
    if (!drawer) return;

    drawer.querySelectorAll('.navigation__tier-1 > .navigation__item').forEach(item => {
      const toggleEl = item.querySelector('.navigation__children-toggle, [data-a11y-submenu="true"]');
      const isActive = item === clickedItem || item.contains(clickedItem);

      if (isActive) {
        // if (toggleEl) toggleEl.setAttribute('aria-expanded', 'true');
        item.classList.add('navigation__item--show-children');
        const tier2 = item.querySelector('.navigation__tier-2-container');
        if (tier2) {
          tier2.removeAttribute('aria-hidden');
          tier2.querySelectorAll('a, button').forEach(el => {
            el.removeAttribute('tabindex');
            el.removeAttribute('aria-hidden');
          });
        }
      } else {
        item.setAttribute('aria-hidden', 'true');
        // if (toggleEl) toggleEl.setAttribute('aria-expanded', 'false');
        item.querySelectorAll('a, button').forEach(el => el.setAttribute('tabindex', '-1'));
      }
    });
  });
})();

// // === #3 - MOBILE DRAWER OPEN/CLOSE FOCUS RETURN 
(function () {
  if (window.__mobileDrawerFocusTrap) return;
  window.__mobileDrawerFocusTrap = true;

  const menuTrigger = document.querySelector('.mobile-nav-toggle[aria-label="Menu"]');

  function returnFocusToTrigger() {
    if (menuTrigger) {
      setTimeout(() => menuTrigger.focus({ preventScroll: true }), 100);
    }
  }

  function focusRealCloseButton() {
    const realClose = document.querySelector('.mobile-navigation-drawer .mobile-nav-toggle[aria-label*="Close"]');
    if (realClose) {
      setTimeout(() => realClose.focus({ preventScroll: true }), 100);
    }
  }

  theme.addDelegateEventListener(document, 'click', '.mobile-nav-toggle[aria-label="Menu"]', function () {
    setTimeout(focusRealCloseButton, 350);
  });

  theme.addDelegateEventListener(document, 'click', '.mobile-nav-toggle[aria-label*="Close"]', returnFocusToTrigger);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.body.classList.contains('reveal-mobile-nav')) {
      const closeBtn = document.querySelector('.mobile-navigation-drawer .mobile-nav-toggle[aria-label*="Close"]');
      if (closeBtn) closeBtn.click();
      returnFocusToTrigger();
    }
  });

  const observer = new MutationObserver(() => {
    if (!document.body.classList.contains('reveal-mobile-nav') && !document.body.classList.contains('toggle-over-flow')) {
      returnFocusToTrigger();
    }
  });
  observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
})();

// // === #7 - PREVENT FOCUS ON MENU SHADE
(function () {
  if (window.__mobileNavShadeFocusPrevented) return;
  window.__mobileNavShadeFocusPrevented = true;

  theme.addDelegateEventListener(document, 'focusin', '.header-shade.mobile-nav-toggle', function (evt) {
    const realClose = document.querySelector('.mobile-navigation-drawer .mobile-nav-toggle[aria-label*="Close"]');
    if (realClose && document.body.classList.contains('reveal-mobile-nav')) {
      evt.preventDefault();
      realClose.focus({ preventScroll: true });
    }
  });
})();

// // === #8 - MOBILE TIER 2 FOCUS ORDER + TIER 1 CONTENT HIDING
(function () {
  if (window.__mobileTier2TabPath) return;
  window.__mobileTier2TabPath = true;

  let tier2Opener = null;
  let pendingTier2Focus = false;

  function getDrawer() {
    return document.querySelector('.mobile-navigation-drawer');
  }

  function getOpenTier2(drawer) {
    return drawer.querySelector('.navigation__tier-1 > .navigation__item--open > .navigation__tier-2-container');
  }

  function getVisibleFocusables(container) {
    return Array.from(
      container.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
    ).filter(el => {
      if (el.offsetParent === null) return false;
      if (el.closest('[aria-hidden="true"]')) return false;
      return true;
    });
  }

  function getTier2Toggles(openTier2) {
    return getVisibleFocusables(openTier2).filter(el => {
      return el.classList.contains('navigation__children-toggle');
    });
  }

  function restoreTier1Focus(drawer) {
    drawer.querySelectorAll('.navigation__tier-1 > .navigation__item').forEach(item => {
      item.removeAttribute('aria-hidden');

      item.querySelectorAll('a, button').forEach(el => {
        const isHiddenParentLink =
          el.matches('.navigation__link.navigation__link--has-toggle[aria-hidden="true"]');

        if (isHiddenParentLink) return;

        el.removeAttribute('tabindex');
      });
    });
  }

  function setMobileMenuExtraContentHidden(drawer, hide) {
    if (!drawer) return;

    const extras = drawer.querySelectorAll(
      '.nosto_element, .mobile-navigation-drawer__footer'
    );

    extras.forEach(el => {
      if (hide) {
        if (!el.hasAttribute('data-a11y-prev-aria-hidden')) {
          el.setAttribute('data-a11y-prev-aria-hidden', el.getAttribute('aria-hidden') || '');
        }

        el.setAttribute('aria-hidden', 'true');
        el.style.visibility = 'hidden';
        el.style.pointerEvents = 'none';
      } else {
        const prevAriaHidden = el.getAttribute('data-a11y-prev-aria-hidden');

        if (prevAriaHidden) {
          el.setAttribute('aria-hidden', prevAriaHidden);
        } else {
          el.removeAttribute('aria-hidden');
        }

        el.removeAttribute('data-a11y-prev-aria-hidden');
        el.style.visibility = '';
        el.style.pointerEvents = '';
      }
    });
  }

  function setTier1OnlyBlocksHidden(drawer, hide) {
    const tier1OnlyBlocks = drawer.querySelectorAll(
      '.navigation__tier-1-container > *:not(.navigation__mobile-header):not(.navigation__tier-1), .mobile-navigation-drawer__footer'
    );

    tier1OnlyBlocks.forEach(block => {
      if (hide) {
        if (!block.hasAttribute('data-a11y-prev-aria-hidden')) {
          block.setAttribute('data-a11y-prev-aria-hidden', block.getAttribute('aria-hidden') || '');
        }

        block.setAttribute('aria-hidden', 'true');

        block.querySelectorAll('a[href], button, [tabindex]').forEach(el => {
          if (!el.hasAttribute('data-a11y-prev-tabindex')) {
            el.setAttribute('data-a11y-prev-tabindex', el.getAttribute('tabindex') || '');
          }

          el.setAttribute('tabindex', '-1');
        });
      } else {
        const prevAriaHidden = block.getAttribute('data-a11y-prev-aria-hidden');

        if (prevAriaHidden) {
          block.setAttribute('aria-hidden', prevAriaHidden);
        } else {
          block.removeAttribute('aria-hidden');
        }

        block.removeAttribute('data-a11y-prev-aria-hidden');

        block.querySelectorAll('[data-a11y-prev-tabindex]').forEach(el => {
          const prevTabindex = el.getAttribute('data-a11y-prev-tabindex');

          if (prevTabindex) {
            el.setAttribute('tabindex', prevTabindex);
          } else {
            el.removeAttribute('tabindex');
          }

          el.removeAttribute('data-a11y-prev-tabindex');
        });
      }
    });
  }

  // prevent the tier 1 nav items from being read in SR when in Tier 2 menu view
  function setTier1ListSemanticsForChildOpen(drawer, disableListSemantics) {
    const tier1List = drawer.querySelector('.navigation__tier-1');
    const openTier1Item = drawer.querySelector('.navigation__tier-1 > .navigation__item--open');

    if (!tier1List) return;

    if (disableListSemantics) {
      tier1List.setAttribute('role', 'presentation');
      setTier1OnlyBlocksHidden(drawer, true);
      
      if (openTier1Item) {
        openTier1Item.setAttribute('role', 'presentation');

        const openTier1Toggle = openTier1Item.querySelector(':scope > .navigation__children-toggle');
        if (openTier1Toggle) {
          openTier1Toggle.setAttribute('aria-hidden', 'true');
          openTier1Toggle.setAttribute('tabindex', '-1');
        }
      }
    } else {
      setTier1OnlyBlocksHidden(drawer, false);
      tier1List.removeAttribute('role');

      drawer.querySelectorAll('.navigation__tier-1 > .navigation__item[role="presentation"]').forEach(item => {
        item.removeAttribute('role');
      });

      drawer.querySelectorAll('.navigation__tier-1 > .navigation__item > .navigation__children-toggle[aria-hidden="true"]').forEach(toggle => {
        toggle.removeAttribute('aria-hidden');
        toggle.removeAttribute('tabindex');
      });
    }
  }

  // Reset expanded mobile submenu state to collapsed when leaving or reopening a menu.
  function resetMobileTier3State(drawer) {
    if (!drawer) return;

    drawer.querySelectorAll('.navigation__tier-2 > .navigation__item--open').forEach(item => {
      item.classList.remove('navigation__item--open');
    });

    drawer.querySelectorAll('.navigation__tier-2 > .navigation__item > .navigation__children-toggle').forEach(toggle => {
      toggle.setAttribute('aria-expanded', 'false');
    });

    drawer.querySelectorAll('.navigation__tier-3-container').forEach(panel => {
      panel.style.height = '';
      panel.setAttribute('aria-hidden', 'true');

      panel.querySelectorAll('a[href], button:not([disabled]), [tabindex]').forEach(el => {
        if (!el.hasAttribute('data-a11y-prev-tabindex')) {
          el.setAttribute('data-a11y-prev-tabindex', el.getAttribute('tabindex') || '');
        }

        el.setAttribute('tabindex', '-1');
      });
    });
  }

  // Ensure Back and Close controls are visible when a Tier 2 menu opens.
  function ensureMobileTier2Header(drawer) {
    if (!drawer) return;

    const header = drawer.querySelector('.navigation__mobile-header');
    if (!header) return;

    header.removeAttribute('aria-hidden');
    header.style.visibility = '';

    header.querySelectorAll('.mobile-nav-back, .mobile-nav-toggle[aria-label*="Close"]').forEach(el => {
      el.removeAttribute('aria-hidden');
      el.removeAttribute('tabindex');
      el.style.visibility = '';
    });
  }

  function focusBackButton() {
    const drawer = getDrawer();
    const backButton = drawer && drawer.querySelector('.mobile-nav-back');
    if (!backButton) return;

    requestAnimationFrame(() => {
      backButton.focus({ preventScroll: true });
    });
  }

  theme.addDelegateEventListener(document, 'click', '.mobile-navigation-drawer .navigation__tier-1 > .navigation__item > .navigation__children-toggle', function (evt, toggle) {
    tier2Opener = toggle;
    pendingTier2Focus = true;

    setTimeout(() => {
      const drawer = getDrawer();
      if (!drawer || !drawer.classList.contains('mobile-navigation-drawer--child-open')) return;
      if (!pendingTier2Focus) return;

      resetMobileTier3State(drawer);
      ensureMobileTier2Header(drawer);

      setTier1ListSemanticsForChildOpen(drawer, true);
      setMobileMenuExtraContentHidden(drawer, true);
      focusBackButton();

      pendingTier2Focus = false;
    }, 80);
  });

  // back btn handler 
  theme.addDelegateEventListener(document, 'click', '.mobile-navigation-drawer .mobile-nav-back', function () {
    const drawer = getDrawer();

    pendingTier2Focus = false;

    if (!tier2Opener || !drawer) return;

    setTimeout(() => {
      resetMobileTier3State(drawer);

      setTier1ListSemanticsForChildOpen(drawer, false);
      setMobileMenuExtraContentHidden(drawer, false);
      restoreTier1Focus(drawer);

      drawer.classList.remove('mobile-navigation-drawer--child-open');

      drawer.querySelectorAll('.navigation__item--open, .navigation__item--show-children').forEach(item => {
        item.classList.remove('navigation__item--open', 'navigation__item--show-children');
      });

      drawer.querySelectorAll('.navigation__tier-2 > .navigation__item > .navigation__children-toggle').forEach(toggle => {
        toggle.setAttribute('aria-expanded', 'false');
      });

      const navTitle = drawer.querySelector('.mobile-nav-title');
      if (navTitle) navTitle.textContent = ''; // clear out Tier 2 heading text when returning to Tier 1 

      tier2Opener.focus({ preventScroll: true });
    }, 80);
  });

  // when menu closes, reset the menu 
  theme.addDelegateEventListener(document, 'click', '.mobile-navigation-drawer .mobile-nav-toggle[aria-label*="Close"]', function () {
    const drawer = getDrawer();

    tier2Opener = null;
    pendingTier2Focus = false;

    if (!drawer) return;

    setTimeout(() => {
      resetMobileTier3State(drawer);

      setTier1ListSemanticsForChildOpen(drawer, false);
      setMobileMenuExtraContentHidden(drawer, false);
      restoreTier1Focus(drawer);

      const navTitle = drawer.querySelector('.mobile-nav-title');
      if (navTitle) navTitle.textContent = ''; // clear out Tier 2 heading text when we closing the menu

      drawer.classList.remove('mobile-navigation-drawer--child-open');

      drawer.querySelectorAll('.navigation__item--open, .navigation__item--show-children').forEach(item => {
        item.classList.remove('navigation__item--open', 'navigation__item--show-children');
      });

      drawer.querySelectorAll('.navigation__tier-2 > .navigation__item > .navigation__children-toggle').forEach(toggle => {
        toggle.setAttribute('aria-expanded', 'false');
      });
    }, 80);
  });

  document.addEventListener('keydown', function (evt) {
    const drawer = getDrawer();
    if (!drawer || !document.body.classList.contains('reveal-mobile-nav')) return;
    if (!drawer.classList.contains('mobile-navigation-drawer--child-open')) return;
    if (evt.key !== 'Tab') return;

    const openTier2 = getOpenTier2(drawer);
    const backButton = drawer.querySelector('.mobile-nav-back');
    const closeButton = drawer.querySelector('.mobile-nav-toggle[aria-label*="Close"]');

    if (!openTier2 || !backButton || !closeButton) return;

    const tier2Toggles = getTier2Toggles(openTier2);
    const firstTier2Toggle = tier2Toggles[0];

    if (!firstTier2Toggle) return;

    if (!evt.shiftKey && document.activeElement === backButton) {
      evt.preventDefault();
      closeButton.focus({ preventScroll: true });
      return;
    }

    if (!evt.shiftKey && document.activeElement === closeButton) {
      evt.preventDefault();
      firstTier2Toggle.focus({ preventScroll: true });
      return;
    }

    if (evt.shiftKey && document.activeElement === firstTier2Toggle) {
      evt.preventDefault();
      closeButton.focus({ preventScroll: true });
      return;
    }

    if (evt.shiftKey && document.activeElement === closeButton) {
      evt.preventDefault();
      backButton.focus({ preventScroll: true });
      return;
    }

  }, true);
})();
 
// // === #9 - MOBILE DRAWER FOCUS TRAP
(function () {
  if (window.__mobileDrawerFullFocusTrap) return;
  window.__mobileDrawerFullFocusTrap = true;

  function getDrawer() {
    return document.querySelector('.mobile-navigation-drawer');
  }

  function getVisibleFocusables(container) {
    return Array.from(
      container.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
    ).filter(el => {
      if (el.offsetParent === null) return false;
      if (el.closest('[aria-hidden="true"]')) return false;
      return true;
    });
  }

  document.addEventListener('keydown', function (evt) {
    if (evt.key !== 'Tab') return;
    if (evt.defaultPrevented) return;
    if (!document.body.classList.contains('reveal-mobile-nav')) return;

    const drawer = getDrawer();
    if (!drawer) return;

    const focusables = getVisibleFocusables(drawer);
    if (!focusables.length) return;

    const first = focusables[0];
    const last = focusables[focusables.length - 1];

    if (evt.shiftKey && document.activeElement === first) {
      evt.preventDefault();
      last.focus({ preventScroll: true });
      return;
    }

    if (!evt.shiftKey && document.activeElement === last) {
      evt.preventDefault();
      first.focus({ preventScroll: true });
    }
  }, true);
})();

// // === #10 - HIDE PAGE CONTENT FROM SCREEN READERS WHEN MOBILE DRAWER IS OPEN
(function () {
  if (window.__mobileDrawerHidePageContent) return;
  window.__mobileDrawerHidePageContent = true;

  const drawer = document.querySelector('.mobile-navigation-drawer');
  if (!drawer) return;

  const hiddenSiblings = [];

  function hidePageContent() {
    Array.from(document.body.children).forEach(el => {
      if (el === drawer) return;
      if (el.contains(drawer)) return;
      if (el.matches('script, style')) return;
      if (el.getAttribute('aria-hidden') === 'true') return;

      hiddenSiblings.push(el);
      el.setAttribute('aria-hidden', 'true');
    });
  }

  function restorePageContent() {
    hiddenSiblings.forEach(el => {
      el.removeAttribute('aria-hidden');
    });

    hiddenSiblings.length = 0;
  }

  const observer = new MutationObserver(() => {
    if (document.body.classList.contains('reveal-mobile-nav')) {
      hidePageContent();
    } else {
      restorePageContent();
    }
  });

  observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
})();

/**** BACKGROUND VIDEO PLAY/PAUSE ****/
// video.js plays background videos on .video-section clicks
// so stopPropagation() prevents the pause button click from immediately restarting the video
document.querySelectorAll('.video-section--background').forEach((section) => {
  const button = section.querySelector('.a11y-background-video-toggle');

  if (!button) return;

  function initVideo() {
    const video = section.querySelector('video');

    if (!video) return false;
    if (button.dataset.a11yVideoBound === 'true') return true;

    button.dataset.a11yVideoBound = 'true';

    button.addEventListener('click', (event) => {
      event.stopPropagation();

      if (video.paused) {
        video.play();
        button.textContent = 'Pause';
        button.setAttribute('aria-label', 'Pause background video');
      } else {
        video.pause();
        button.textContent = 'Play';
        button.setAttribute('aria-label', 'Play background video');
      }
    });

    return true;
  }

  if (initVideo()) return;

  const observer = new MutationObserver(() => {
    if (initVideo()) {
      observer.disconnect();
    }
  });

  observer.observe(section, {
    childList: true,
    subtree: true
  });
});

/**** MOVING TICKER TYPE MARQUEE ****/
document.querySelectorAll('.a11y-marquee-toggle').forEach(function (button) {
  button.addEventListener('click', function () {
    var marqueeSection = button.closest('[class*="marquee-section-"]');

    if (!marqueeSection) return;

    var track = marqueeSection.querySelector('[class*="marquee-track-"]');
    var label = button.querySelector('[data-marquee-label]');

    if (!track || !label) return;

    var isPaused = button.getAttribute('aria-pressed') === 'true';

    track.style.animationPlayState = isPaused ? 'running' : 'paused';

    button.setAttribute('aria-pressed', isPaused ? 'false' : 'true');

    var buttonLabel = isPaused
      ? 'Pause scrolling text'
      : 'Resume scrolling text';

    button.setAttribute('aria-label', buttonLabel);
    label.textContent = buttonLabel;
  });
});
 


